/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsLayoutRouteImport } from './routes/uns/_layout'
import { Route as StorageHubLayoutRouteImport } from './routes/storage-hub/_layout'
import { Route as SourcesLayoutRouteImport } from './routes/sources/_layout'
import { Route as ResourcesLayoutRouteImport } from './routes/resources/_layout'
import { Route as IdentityAndAccessLayoutRouteImport } from './routes/identity-and-access/_layout'
import { Route as AdminLayoutRouteImport } from './routes/admin/_layout'
import { Route as UnsIndexRouteImport } from './routes/uns/index'
import { Route as StorageHubIndexRouteImport } from './routes/storage-hub/index'
import { Route as SourcesIndexRouteImport } from './routes/sources/index'
import { Route as ResourcesIndexRouteImport } from './routes/resources/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as IdentityAndAccessIndexRouteImport } from './routes/identity-and-access/index'
import { Route as DashboardsIndexRouteImport } from './routes/dashboards/index'
import { Route as CaptureIndexRouteImport } from './routes/capture/index'
import { Route as CaptainAiIndexRouteImport } from './routes/captain-ai/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as CaptainAiChatIdRouteImport } from './routes/captain-ai/$chatId'
import { Route as AppIdRouteImport } from './routes/app/$id'
import { Route as StorageHubCaptureStorageLayoutRouteImport } from './routes/storage-hub/capture-storage/_layout'
import { Route as ResourcesIdLayoutRouteImport } from './routes/resources/$id/_layout'
import { Route as UnsUnsBuilderIndexRouteImport } from './routes/uns/uns-builder/index'
import { Route as UnsMetadatabundlesIndexRouteImport } from './routes/uns/metadatabundles/index'
import { Route as UnsDataExplorerIndexRouteImport } from './routes/uns/data-explorer/index'
import { Route as StorageHubCaptureStorageIndexRouteImport } from './routes/storage-hub/capture-storage/index'
import { Route as SourcesProjectsIndexRouteImport } from './routes/sources/projects/index'
import { Route as SourcesFleetsIndexRouteImport } from './routes/sources/fleets/index'
import { Route as SourcesEdgeGatewaysIndexRouteImport } from './routes/sources/edge-gateways/index'
import { Route as SourcesConfigurationsIndexRouteImport } from './routes/sources/configurations/index'
import { Route as ResourcesIdIndexRouteImport } from './routes/resources/$id/index'
import { Route as IdentityAndAccessUsersIndexRouteImport } from './routes/identity-and-access/users/index'
import { Route as IdentityAndAccessRolesIndexRouteImport } from './routes/identity-and-access/roles/index'
import { Route as IdentityAndAccessGroupsIndexRouteImport } from './routes/identity-and-access/groups/index'
import { Route as IdentityAndAccessCompaniesIndexRouteImport } from './routes/identity-and-access/companies/index'
import { Route as IdentityAndAccessApiTokensIndexRouteImport } from './routes/identity-and-access/api-tokens/index'
import { Route as DashboardsIdIndexRouteImport } from './routes/dashboards/$id/index'
import { Route as AdminTermsAndPrivacyIndexRouteImport } from './routes/admin/terms-and-privacy/index'
import { Route as AdminNativeAppsIndexRouteImport } from './routes/admin/native-apps/index'
import { Route as AdminCustomAppsIndexRouteImport } from './routes/admin/custom-apps/index'
import { Route as AdminCacheIndexRouteImport } from './routes/admin/cache/index'
import { Route as AdminAnnouncementsIndexRouteImport } from './routes/admin/announcements/index'
import { Route as ResourcesIdGeneralRouteImport } from './routes/resources/$id/general'
import { Route as SourcesProjectsIdLayoutRouteImport } from './routes/sources/projects/$id/_layout'
import { Route as SourcesFleetsIdLayoutRouteImport } from './routes/sources/fleets/$id/_layout'
import { Route as SourcesEdgeGatewaysIdLayoutRouteImport } from './routes/sources/edge-gateways/$id/_layout'
import { Route as SourcesConfigurationsIdLayoutRouteImport } from './routes/sources/configurations/$id/_layout'
import { Route as ResourcesIdVersionsLayoutRouteImport } from './routes/resources/$id/versions/_layout'
import { Route as ResourcesIdLinkedToLayoutRouteImport } from './routes/resources/$id/linked-to/_layout'
import { Route as IdentityAndAccessApiTokensNewLayoutRouteImport } from './routes/identity-and-access/api-tokens/new/_layout'
import { Route as IdentityAndAccessApiTokensIdLayoutRouteImport } from './routes/identity-and-access/api-tokens/$id/_layout'
import { Route as StorageHubCaptureStorageDatabaseIndexRouteImport } from './routes/storage-hub/capture-storage/database/index'
import { Route as StorageHubCaptureStorageBlobIndexRouteImport } from './routes/storage-hub/capture-storage/blob/index'
import { Route as SourcesProjectsIdIndexRouteImport } from './routes/sources/projects/$id/index'
import { Route as SourcesFleetsIdIndexRouteImport } from './routes/sources/fleets/$id/index'
import { Route as SourcesEdgeGatewaysIdIndexRouteImport } from './routes/sources/edge-gateways/$id/index'
import { Route as ResourcesIdVersionsIndexRouteImport } from './routes/resources/$id/versions/index'
import { Route as ResourcesIdLinkedToIndexRouteImport } from './routes/resources/$id/linked-to/index'
import { Route as SourcesEdgeGatewaysIdVariablesRouteImport } from './routes/sources/edge-gateways/$id/variables'
import { Route as SourcesEdgeGatewaysIdSettingsRouteImport } from './routes/sources/edge-gateways/$id/settings'
import { Route as SourcesEdgeGatewaysIdResourcesRouteImport } from './routes/sources/edge-gateways/$id/resources'
import { Route as SourcesEdgeGatewaysIdOverviewRouteImport } from './routes/sources/edge-gateways/$id/overview'
import { Route as SourcesEdgeGatewaysIdCloudStorageRouteImport } from './routes/sources/edge-gateways/$id/cloud-storage'
import { Route as SourcesEdgeGatewaysIdAlertsRouteImport } from './routes/sources/edge-gateways/$id/alerts'
import { Route as ResourcesIdLinkedToProjectsRouteImport } from './routes/resources/$id/linked-to/projects'
import { Route as ResourcesIdLinkedToFleetsRouteImport } from './routes/resources/$id/linked-to/fleets'
import { Route as ResourcesIdLinkedToEdgeGatewaysRouteImport } from './routes/resources/$id/linked-to/edge-gateways'
import { Route as IdentityAndAccessApiTokensNewPermissionsRouteImport } from './routes/identity-and-access/api-tokens/new/permissions'
import { Route as IdentityAndAccessApiTokensNewGeneralRouteImport } from './routes/identity-and-access/api-tokens/new/general'
import { Route as IdentityAndAccessApiTokensNewDatabasesRouteImport } from './routes/identity-and-access/api-tokens/new/databases'
import { Route as IdentityAndAccessApiTokensIdPermissionsRouteImport } from './routes/identity-and-access/api-tokens/$id/permissions'
import { Route as IdentityAndAccessApiTokensIdGeneralRouteImport } from './routes/identity-and-access/api-tokens/$id/general'
import { Route as IdentityAndAccessApiTokensIdDatabasesRouteImport } from './routes/identity-and-access/api-tokens/$id/databases'
import { Route as StorageHubCaptureStorageDatabaseIdLayoutRouteImport } from './routes/storage-hub/capture-storage/database/$id/_layout'
import { Route as StorageHubCaptureStorageBlobIdLayoutRouteImport } from './routes/storage-hub/capture-storage/blob/$id/_layout'
import { Route as SourcesProjectsIdReportsLayoutRouteImport } from './routes/sources/projects/$id/reports/_layout'
import { Route as SourcesFleetsIdCloudStorageLayoutRouteImport } from './routes/sources/fleets/$id/cloud-storage/_layout'
import { Route as SourcesFleetsIdAlertsLayoutRouteImport } from './routes/sources/fleets/$id/alerts/_layout'
import { Route as SourcesEdgeGatewaysIdMessagesLayoutRouteImport } from './routes/sources/edge-gateways/$id/messages/_layout'
import { Route as ResourcesIdVersionsNewLayoutRouteImport } from './routes/resources/$id/versions/new/_layout'
import { Route as ResourcesIdVersionsVersionIdLayoutRouteImport } from './routes/resources/$id/versions/$versionId/_layout'
import { Route as StorageHubCaptureStorageDatabaseIdIndexRouteImport } from './routes/storage-hub/capture-storage/database/$id/index'
import { Route as StorageHubCaptureStorageBlobIdIndexRouteImport } from './routes/storage-hub/capture-storage/blob/$id/index'
import { Route as SourcesProjectsIdResourcesIndexRouteImport } from './routes/sources/projects/$id/resources/index'
import { Route as SourcesProjectsIdReportsIndexRouteImport } from './routes/sources/projects/$id/reports/index'
import { Route as SourcesProjectsIdGeneralIndexRouteImport } from './routes/sources/projects/$id/general/index'
import { Route as SourcesProjectsIdEdgeGatewaysIndexRouteImport } from './routes/sources/projects/$id/edge-gateways/index'
import { Route as SourcesProjectsIdDashboardsIndexRouteImport } from './routes/sources/projects/$id/dashboards/index'
import { Route as SourcesFleetsIdResourcesIndexRouteImport } from './routes/sources/fleets/$id/resources/index'
import { Route as SourcesFleetsIdReportsIndexRouteImport } from './routes/sources/fleets/$id/reports/index'
import { Route as SourcesFleetsIdGeneralIndexRouteImport } from './routes/sources/fleets/$id/general/index'
import { Route as SourcesFleetsIdEdgeGatewaysIndexRouteImport } from './routes/sources/fleets/$id/edge-gateways/index'
import { Route as SourcesFleetsIdDashboardsIndexRouteImport } from './routes/sources/fleets/$id/dashboards/index'
import { Route as SourcesFleetsIdConfigurationsIndexRouteImport } from './routes/sources/fleets/$id/configurations/index'
import { Route as SourcesFleetsIdCloudStorageIndexRouteImport } from './routes/sources/fleets/$id/cloud-storage/index'
import { Route as SourcesFleetsIdAlertsIndexRouteImport } from './routes/sources/fleets/$id/alerts/index'
import { Route as SourcesEdgeGatewaysIdMessagesIndexRouteImport } from './routes/sources/edge-gateways/$id/messages/index'
import { Route as ResourcesIdVersionsVersionIdIndexRouteImport } from './routes/resources/$id/versions/$versionId/index'
import { Route as StorageHubCaptureStorageDatabaseIdSettingsRouteImport } from './routes/storage-hub/capture-storage/database/$id/settings'
import { Route as StorageHubCaptureStorageDatabaseIdPermissionsRouteImport } from './routes/storage-hub/capture-storage/database/$id/permissions'
import { Route as StorageHubCaptureStorageDatabaseIdMeasurementsRouteImport } from './routes/storage-hub/capture-storage/database/$id/measurements'
import { Route as StorageHubCaptureStorageBlobIdSettingsRouteImport } from './routes/storage-hub/capture-storage/blob/$id/settings'
import { Route as ResourcesIdVersionsNewVariablesRouteImport } from './routes/resources/$id/versions/new/variables'
import { Route as ResourcesIdVersionsNewGeneralRouteImport } from './routes/resources/$id/versions/new/general'
import { Route as ResourcesIdVersionsVersionIdVariablesRouteImport } from './routes/resources/$id/versions/$versionId/variables'
import { Route as ResourcesIdVersionsVersionIdGeneralRouteImport } from './routes/resources/$id/versions/$versionId/general'
import { Route as SourcesFleetsIdAlertsNoDataAlertLayoutRouteImport } from './routes/sources/fleets/$id/alerts/no-data-alert/_layout'
import { Route as SourcesProjectsIdReportsReportConfigIdIndexRouteImport } from './routes/sources/projects/$id/reports/$reportConfigId/index'
import { Route as SourcesFleetsIdCloudStorageParentDbSyncIndexRouteImport } from './routes/sources/fleets/$id/cloud-storage/parent-db-sync/index'
import { Route as SourcesFleetsIdCloudStorageDatabasesIndexRouteImport } from './routes/sources/fleets/$id/cloud-storage/databases/index'
import { Route as SourcesFleetsIdAlertsNoDataAlertIndexRouteImport } from './routes/sources/fleets/$id/alerts/no-data-alert/index'
import { Route as SourcesFleetsIdAlertsAlertIdIndexRouteImport } from './routes/sources/fleets/$id/alerts/$alertId/index'
import { Route as SourcesEdgeGatewaysIdMessagesAppIndexRouteImport } from './routes/sources/edge-gateways/$id/messages/$app/index'
import { Route as SourcesFleetsIdAlertsNoDataAlertTriggerRouteImport } from './routes/sources/fleets/$id/alerts/no-data-alert/trigger'
import { Route as SourcesFleetsIdAlertsNoDataAlertNotificationRouteImport } from './routes/sources/fleets/$id/alerts/no-data-alert/notification'
import { Route as SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteImport } from './routes/sources/edge-gateways/$id/messages/$app/$tab/_layout'
import { Route as SourcesEdgeGatewaysIdMessagesAppTabIndexRouteImport } from './routes/sources/edge-gateways/$id/messages/$app/$tab/index'

const IndexLazyRouteImport = createFileRoute('/')()
const UnsHomeIndexLazyRouteImport = createFileRoute('/uns/home/')()
const SourcesHomeIndexLazyRouteImport = createFileRoute('/sources/home/')()
const IdentityAndAccessHomeIndexLazyRouteImport = createFileRoute(
  '/identity-and-access/home/',
)()
const AdminHomeIndexLazyRouteImport = createFileRoute('/admin/home/')()

const UnsLayoutRoute = UnsLayoutRouteImport.update({
  id: '/uns',
  path: '/uns',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/uns/_layout.lazy').then((d) => d.Route))
const StorageHubLayoutRoute = StorageHubLayoutRouteImport.update({
  id: '/storage-hub',
  path: '/storage-hub',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/storage-hub/_layout.lazy').then((d) => d.Route),
)
const SourcesLayoutRoute = SourcesLayoutRouteImport.update({
  id: '/sources',
  path: '/sources',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/sources/_layout.lazy').then((d) => d.Route),
)
const ResourcesLayoutRoute = ResourcesLayoutRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/resources/_layout.lazy').then((d) => d.Route),
)
const IdentityAndAccessLayoutRoute = IdentityAndAccessLayoutRouteImport.update({
  id: '/identity-and-access',
  path: '/identity-and-access',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/identity-and-access/_layout.lazy').then((d) => d.Route),
)
const AdminLayoutRoute = AdminLayoutRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin/_layout.lazy').then((d) => d.Route))
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const UnsIndexRoute = UnsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UnsLayoutRoute,
} as any)
const StorageHubIndexRoute = StorageHubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StorageHubLayoutRoute,
} as any)
const SourcesIndexRoute = SourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SourcesLayoutRoute,
} as any)
const ResourcesIndexRoute = ResourcesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/resources/index.lazy').then((d) => d.Route),
)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/login/index.lazy').then((d) => d.Route))
const IdentityAndAccessIndexRoute = IdentityAndAccessIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IdentityAndAccessLayoutRoute,
} as any)
const DashboardsIndexRoute = DashboardsIndexRouteImport.update({
  id: '/dashboards/',
  path: '/dashboards/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/dashboards/index.lazy').then((d) => d.Route),
)
const CaptureIndexRoute = CaptureIndexRouteImport.update({
  id: '/capture/',
  path: '/capture/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/capture/index.lazy').then((d) => d.Route))
const CaptainAiIndexRoute = CaptainAiIndexRouteImport.update({
  id: '/captain-ai/',
  path: '/captain-ai/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/captain-ai/index.lazy').then((d) => d.Route),
)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLayoutRoute,
} as any)
const CaptainAiChatIdRoute = CaptainAiChatIdRouteImport.update({
  id: '/captain-ai/$chatId',
  path: '/captain-ai/$chatId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/captain-ai/$chatId.lazy').then((d) => d.Route),
)
const AppIdRoute = AppIdRouteImport.update({
  id: '/app/$id',
  path: '/app/$id',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/app/$id.lazy').then((d) => d.Route))
const StorageHubCaptureStorageLayoutRoute =
  StorageHubCaptureStorageLayoutRouteImport.update({
    id: '/capture-storage',
    path: '/capture-storage',
    getParentRoute: () => StorageHubLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdLayoutRoute = ResourcesIdLayoutRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => ResourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/resources/$id/_layout.lazy').then((d) => d.Route),
)
const UnsHomeIndexLazyRoute = UnsHomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => UnsLayoutRoute,
} as any).lazy(() =>
  import('./routes/uns/home/index.lazy').then((d) => d.Route),
)
const SourcesHomeIndexLazyRoute = SourcesHomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => SourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/sources/home/index.lazy').then((d) => d.Route),
)
const IdentityAndAccessHomeIndexLazyRoute =
  IdentityAndAccessHomeIndexLazyRouteImport.update({
    id: '/home/',
    path: '/home/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/home/index.lazy').then((d) => d.Route),
  )
const AdminHomeIndexLazyRoute = AdminHomeIndexLazyRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() =>
  import('./routes/admin/home/index.lazy').then((d) => d.Route),
)
const UnsUnsBuilderIndexRoute = UnsUnsBuilderIndexRouteImport.update({
  id: '/uns-builder/',
  path: '/uns-builder/',
  getParentRoute: () => UnsLayoutRoute,
} as any).lazy(() =>
  import('./routes/uns/uns-builder/index.lazy').then((d) => d.Route),
)
const UnsMetadatabundlesIndexRoute = UnsMetadatabundlesIndexRouteImport.update({
  id: '/metadatabundles/',
  path: '/metadatabundles/',
  getParentRoute: () => UnsLayoutRoute,
} as any).lazy(() =>
  import('./routes/uns/metadatabundles/index.lazy').then((d) => d.Route),
)
const UnsDataExplorerIndexRoute = UnsDataExplorerIndexRouteImport.update({
  id: '/data-explorer/',
  path: '/data-explorer/',
  getParentRoute: () => UnsLayoutRoute,
} as any).lazy(() =>
  import('./routes/uns/data-explorer/index.lazy').then((d) => d.Route),
)
const StorageHubCaptureStorageIndexRoute =
  StorageHubCaptureStorageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StorageHubCaptureStorageLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIndexRoute = SourcesProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => SourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/sources/projects/index.lazy').then((d) => d.Route),
)
const SourcesFleetsIndexRoute = SourcesFleetsIndexRouteImport.update({
  id: '/fleets/',
  path: '/fleets/',
  getParentRoute: () => SourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/sources/fleets/index.lazy').then((d) => d.Route),
)
const SourcesEdgeGatewaysIndexRoute =
  SourcesEdgeGatewaysIndexRouteImport.update({
    id: '/edge-gateways/',
    path: '/edge-gateways/',
    getParentRoute: () => SourcesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/index.lazy').then((d) => d.Route),
  )
const SourcesConfigurationsIndexRoute =
  SourcesConfigurationsIndexRouteImport.update({
    id: '/configurations/',
    path: '/configurations/',
    getParentRoute: () => SourcesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/configurations/index.lazy').then((d) => d.Route),
  )
const ResourcesIdIndexRoute = ResourcesIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ResourcesIdLayoutRoute,
} as any)
const IdentityAndAccessUsersIndexRoute =
  IdentityAndAccessUsersIndexRouteImport.update({
    id: '/users/',
    path: '/users/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/users/index.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessRolesIndexRoute =
  IdentityAndAccessRolesIndexRouteImport.update({
    id: '/roles/',
    path: '/roles/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/roles/index.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessGroupsIndexRoute =
  IdentityAndAccessGroupsIndexRouteImport.update({
    id: '/groups/',
    path: '/groups/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/groups/index.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessCompaniesIndexRoute =
  IdentityAndAccessCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/companies/index.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensIndexRoute =
  IdentityAndAccessApiTokensIndexRouteImport.update({
    id: '/api-tokens/',
    path: '/api-tokens/',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/index.lazy').then(
      (d) => d.Route,
    ),
  )
const DashboardsIdIndexRoute = DashboardsIdIndexRouteImport.update({
  id: '/dashboards/$id/',
  path: '/dashboards/$id/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/dashboards/$id/index.lazy').then((d) => d.Route),
)
const AdminTermsAndPrivacyIndexRoute =
  AdminTermsAndPrivacyIndexRouteImport.update({
    id: '/terms-and-privacy/',
    path: '/terms-and-privacy/',
    getParentRoute: () => AdminLayoutRoute,
  } as any).lazy(() =>
    import('./routes/admin/terms-and-privacy/index.lazy').then((d) => d.Route),
  )
const AdminNativeAppsIndexRoute = AdminNativeAppsIndexRouteImport.update({
  id: '/native-apps/',
  path: '/native-apps/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() =>
  import('./routes/admin/native-apps/index.lazy').then((d) => d.Route),
)
const AdminCustomAppsIndexRoute = AdminCustomAppsIndexRouteImport.update({
  id: '/custom-apps/',
  path: '/custom-apps/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() =>
  import('./routes/admin/custom-apps/index.lazy').then((d) => d.Route),
)
const AdminCacheIndexRoute = AdminCacheIndexRouteImport.update({
  id: '/cache/',
  path: '/cache/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() =>
  import('./routes/admin/cache/index.lazy').then((d) => d.Route),
)
const AdminAnnouncementsIndexRoute = AdminAnnouncementsIndexRouteImport.update({
  id: '/announcements/',
  path: '/announcements/',
  getParentRoute: () => AdminLayoutRoute,
} as any).lazy(() =>
  import('./routes/admin/announcements/index.lazy').then((d) => d.Route),
)
const ResourcesIdGeneralRoute = ResourcesIdGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => ResourcesIdLayoutRoute,
} as any).lazy(() =>
  import('./routes/resources/$id/general.lazy').then((d) => d.Route),
)
const SourcesProjectsIdLayoutRoute = SourcesProjectsIdLayoutRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => SourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/sources/projects/$id/_layout.lazy').then((d) => d.Route),
)
const SourcesFleetsIdLayoutRoute = SourcesFleetsIdLayoutRouteImport.update({
  id: '/fleets/$id',
  path: '/fleets/$id',
  getParentRoute: () => SourcesLayoutRoute,
} as any).lazy(() =>
  import('./routes/sources/fleets/$id/_layout.lazy').then((d) => d.Route),
)
const SourcesEdgeGatewaysIdLayoutRoute =
  SourcesEdgeGatewaysIdLayoutRouteImport.update({
    id: '/edge-gateways/$id',
    path: '/edge-gateways/$id',
    getParentRoute: () => SourcesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesConfigurationsIdLayoutRoute =
  SourcesConfigurationsIdLayoutRouteImport.update({
    id: '/configurations/$id',
    path: '/configurations/$id',
    getParentRoute: () => SourcesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/configurations/$id/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsLayoutRoute =
  ResourcesIdVersionsLayoutRouteImport.update({
    id: '/versions',
    path: '/versions',
    getParentRoute: () => ResourcesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/_layout.lazy').then((d) => d.Route),
  )
const ResourcesIdLinkedToLayoutRoute =
  ResourcesIdLinkedToLayoutRouteImport.update({
    id: '/linked-to',
    path: '/linked-to',
    getParentRoute: () => ResourcesIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/linked-to/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensNewLayoutRoute =
  IdentityAndAccessApiTokensNewLayoutRouteImport.update({
    id: '/api-tokens/new',
    path: '/api-tokens/new',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/new/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensIdLayoutRoute =
  IdentityAndAccessApiTokensIdLayoutRouteImport.update({
    id: '/api-tokens/$id',
    path: '/api-tokens/$id',
    getParentRoute: () => IdentityAndAccessLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/$id/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageDatabaseIndexRoute =
  StorageHubCaptureStorageDatabaseIndexRouteImport.update({
    id: '/database/',
    path: '/database/',
    getParentRoute: () => StorageHubCaptureStorageLayoutRoute,
  } as any)
const StorageHubCaptureStorageBlobIndexRoute =
  StorageHubCaptureStorageBlobIndexRouteImport.update({
    id: '/blob/',
    path: '/blob/',
    getParentRoute: () => StorageHubCaptureStorageLayoutRoute,
  } as any)
const SourcesProjectsIdIndexRoute = SourcesProjectsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SourcesProjectsIdLayoutRoute,
} as any)
const SourcesFleetsIdIndexRoute = SourcesFleetsIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SourcesFleetsIdLayoutRoute,
} as any)
const SourcesEdgeGatewaysIdIndexRoute =
  SourcesEdgeGatewaysIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any)
const ResourcesIdVersionsIndexRoute =
  ResourcesIdVersionsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ResourcesIdVersionsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/index.lazy').then((d) => d.Route),
  )
const ResourcesIdLinkedToIndexRoute =
  ResourcesIdLinkedToIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ResourcesIdLinkedToLayoutRoute,
  } as any)
const SourcesEdgeGatewaysIdVariablesRoute =
  SourcesEdgeGatewaysIdVariablesRouteImport.update({
    id: '/variables',
    path: '/variables',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/variables.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdSettingsRoute =
  SourcesEdgeGatewaysIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdResourcesRoute =
  SourcesEdgeGatewaysIdResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/resources.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdOverviewRoute =
  SourcesEdgeGatewaysIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/overview.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdCloudStorageRoute =
  SourcesEdgeGatewaysIdCloudStorageRouteImport.update({
    id: '/cloud-storage',
    path: '/cloud-storage',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/cloud-storage.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdAlertsRoute =
  SourcesEdgeGatewaysIdAlertsRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/alerts.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdLinkedToProjectsRoute =
  ResourcesIdLinkedToProjectsRouteImport.update({
    id: '/projects',
    path: '/projects',
    getParentRoute: () => ResourcesIdLinkedToLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/linked-to/projects.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdLinkedToFleetsRoute =
  ResourcesIdLinkedToFleetsRouteImport.update({
    id: '/fleets',
    path: '/fleets',
    getParentRoute: () => ResourcesIdLinkedToLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/linked-to/fleets.lazy').then((d) => d.Route),
  )
const ResourcesIdLinkedToEdgeGatewaysRoute =
  ResourcesIdLinkedToEdgeGatewaysRouteImport.update({
    id: '/edge-gateways',
    path: '/edge-gateways',
    getParentRoute: () => ResourcesIdLinkedToLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/linked-to/edge-gateways.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensNewPermissionsRoute =
  IdentityAndAccessApiTokensNewPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => IdentityAndAccessApiTokensNewLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/new/permissions.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensNewGeneralRoute =
  IdentityAndAccessApiTokensNewGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => IdentityAndAccessApiTokensNewLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/new/general.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensNewDatabasesRoute =
  IdentityAndAccessApiTokensNewDatabasesRouteImport.update({
    id: '/databases',
    path: '/databases',
    getParentRoute: () => IdentityAndAccessApiTokensNewLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/new/databases.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensIdPermissionsRoute =
  IdentityAndAccessApiTokensIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => IdentityAndAccessApiTokensIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/$id/permissions.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensIdGeneralRoute =
  IdentityAndAccessApiTokensIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => IdentityAndAccessApiTokensIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/$id/general.lazy').then(
      (d) => d.Route,
    ),
  )
const IdentityAndAccessApiTokensIdDatabasesRoute =
  IdentityAndAccessApiTokensIdDatabasesRouteImport.update({
    id: '/databases',
    path: '/databases',
    getParentRoute: () => IdentityAndAccessApiTokensIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/identity-and-access/api-tokens/$id/databases.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageDatabaseIdLayoutRoute =
  StorageHubCaptureStorageDatabaseIdLayoutRouteImport.update({
    id: '/database/$id',
    path: '/database/$id',
    getParentRoute: () => StorageHubCaptureStorageLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/database/$id/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageBlobIdLayoutRoute =
  StorageHubCaptureStorageBlobIdLayoutRouteImport.update({
    id: '/blob/$id',
    path: '/blob/$id',
    getParentRoute: () => StorageHubCaptureStorageLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/blob/$id/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdReportsLayoutRoute =
  SourcesProjectsIdReportsLayoutRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => SourcesProjectsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/reports/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdCloudStorageLayoutRoute =
  SourcesFleetsIdCloudStorageLayoutRouteImport.update({
    id: '/cloud-storage',
    path: '/cloud-storage',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/cloud-storage/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdAlertsLayoutRoute =
  SourcesFleetsIdAlertsLayoutRouteImport.update({
    id: '/alerts',
    path: '/alerts',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/alerts/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdMessagesLayoutRoute =
  SourcesEdgeGatewaysIdMessagesLayoutRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => SourcesEdgeGatewaysIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/messages/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsNewLayoutRoute =
  ResourcesIdVersionsNewLayoutRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => ResourcesIdVersionsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/new/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsVersionIdLayoutRoute =
  ResourcesIdVersionsVersionIdLayoutRouteImport.update({
    id: '/$versionId',
    path: '/$versionId',
    getParentRoute: () => ResourcesIdVersionsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/$versionId/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageDatabaseIdIndexRoute =
  StorageHubCaptureStorageDatabaseIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StorageHubCaptureStorageDatabaseIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/database/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageBlobIdIndexRoute =
  StorageHubCaptureStorageBlobIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StorageHubCaptureStorageBlobIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/blob/$id/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdResourcesIndexRoute =
  SourcesProjectsIdResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => SourcesProjectsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/resources/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdReportsIndexRoute =
  SourcesProjectsIdReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesProjectsIdReportsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdGeneralIndexRoute =
  SourcesProjectsIdGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => SourcesProjectsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/general/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdEdgeGatewaysIndexRoute =
  SourcesProjectsIdEdgeGatewaysIndexRouteImport.update({
    id: '/edge-gateways/',
    path: '/edge-gateways/',
    getParentRoute: () => SourcesProjectsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/edge-gateways/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdDashboardsIndexRoute =
  SourcesProjectsIdDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => SourcesProjectsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdResourcesIndexRoute =
  SourcesFleetsIdResourcesIndexRouteImport.update({
    id: '/resources/',
    path: '/resources/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/resources/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdReportsIndexRoute =
  SourcesFleetsIdReportsIndexRouteImport.update({
    id: '/reports/',
    path: '/reports/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/reports/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdGeneralIndexRoute =
  SourcesFleetsIdGeneralIndexRouteImport.update({
    id: '/general/',
    path: '/general/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/general/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdEdgeGatewaysIndexRoute =
  SourcesFleetsIdEdgeGatewaysIndexRouteImport.update({
    id: '/edge-gateways/',
    path: '/edge-gateways/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/edge-gateways/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdDashboardsIndexRoute =
  SourcesFleetsIdDashboardsIndexRouteImport.update({
    id: '/dashboards/',
    path: '/dashboards/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/dashboards/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdConfigurationsIndexRoute =
  SourcesFleetsIdConfigurationsIndexRouteImport.update({
    id: '/configurations/',
    path: '/configurations/',
    getParentRoute: () => SourcesFleetsIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/configurations/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdCloudStorageIndexRoute =
  SourcesFleetsIdCloudStorageIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesFleetsIdCloudStorageLayoutRoute,
  } as any)
const SourcesFleetsIdAlertsIndexRoute =
  SourcesFleetsIdAlertsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesFleetsIdAlertsLayoutRoute,
  } as any)
const SourcesEdgeGatewaysIdMessagesIndexRoute =
  SourcesEdgeGatewaysIdMessagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesEdgeGatewaysIdMessagesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/messages/index.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsVersionIdIndexRoute =
  ResourcesIdVersionsVersionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ResourcesIdVersionsVersionIdLayoutRoute,
  } as any)
const StorageHubCaptureStorageDatabaseIdSettingsRoute =
  StorageHubCaptureStorageDatabaseIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StorageHubCaptureStorageDatabaseIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/database/$id/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageDatabaseIdPermissionsRoute =
  StorageHubCaptureStorageDatabaseIdPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => StorageHubCaptureStorageDatabaseIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/database/$id/permissions.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageDatabaseIdMeasurementsRoute =
  StorageHubCaptureStorageDatabaseIdMeasurementsRouteImport.update({
    id: '/measurements',
    path: '/measurements',
    getParentRoute: () => StorageHubCaptureStorageDatabaseIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/database/$id/measurements.lazy').then(
      (d) => d.Route,
    ),
  )
const StorageHubCaptureStorageBlobIdSettingsRoute =
  StorageHubCaptureStorageBlobIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => StorageHubCaptureStorageBlobIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/storage-hub/capture-storage/blob/$id/settings.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsNewVariablesRoute =
  ResourcesIdVersionsNewVariablesRouteImport.update({
    id: '/variables',
    path: '/variables',
    getParentRoute: () => ResourcesIdVersionsNewLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/new/variables.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsNewGeneralRoute =
  ResourcesIdVersionsNewGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => ResourcesIdVersionsNewLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/new/general.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsVersionIdVariablesRoute =
  ResourcesIdVersionsVersionIdVariablesRouteImport.update({
    id: '/variables',
    path: '/variables',
    getParentRoute: () => ResourcesIdVersionsVersionIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/$versionId/variables.lazy').then(
      (d) => d.Route,
    ),
  )
const ResourcesIdVersionsVersionIdGeneralRoute =
  ResourcesIdVersionsVersionIdGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => ResourcesIdVersionsVersionIdLayoutRoute,
  } as any).lazy(() =>
    import('./routes/resources/$id/versions/$versionId/general.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdAlertsNoDataAlertLayoutRoute =
  SourcesFleetsIdAlertsNoDataAlertLayoutRouteImport.update({
    id: '/no-data-alert',
    path: '/no-data-alert',
    getParentRoute: () => SourcesFleetsIdAlertsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/alerts/no-data-alert/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesProjectsIdReportsReportConfigIdIndexRoute =
  SourcesProjectsIdReportsReportConfigIdIndexRouteImport.update({
    id: '/$reportConfigId/',
    path: '/$reportConfigId/',
    getParentRoute: () => SourcesProjectsIdReportsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/projects/$id/reports/$reportConfigId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdCloudStorageParentDbSyncIndexRoute =
  SourcesFleetsIdCloudStorageParentDbSyncIndexRouteImport.update({
    id: '/parent-db-sync/',
    path: '/parent-db-sync/',
    getParentRoute: () => SourcesFleetsIdCloudStorageLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/cloud-storage/parent-db-sync/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdCloudStorageDatabasesIndexRoute =
  SourcesFleetsIdCloudStorageDatabasesIndexRouteImport.update({
    id: '/databases/',
    path: '/databases/',
    getParentRoute: () => SourcesFleetsIdCloudStorageLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/cloud-storage/databases/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdAlertsNoDataAlertIndexRoute =
  SourcesFleetsIdAlertsNoDataAlertIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesFleetsIdAlertsNoDataAlertLayoutRoute,
  } as any)
const SourcesFleetsIdAlertsAlertIdIndexRoute =
  SourcesFleetsIdAlertsAlertIdIndexRouteImport.update({
    id: '/$alertId/',
    path: '/$alertId/',
    getParentRoute: () => SourcesFleetsIdAlertsLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/alerts/$alertId/index.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdMessagesAppIndexRoute =
  SourcesEdgeGatewaysIdMessagesAppIndexRouteImport.update({
    id: '/$app/',
    path: '/$app/',
    getParentRoute: () => SourcesEdgeGatewaysIdMessagesLayoutRoute,
  } as any)
const SourcesFleetsIdAlertsNoDataAlertTriggerRoute =
  SourcesFleetsIdAlertsNoDataAlertTriggerRouteImport.update({
    id: '/trigger',
    path: '/trigger',
    getParentRoute: () => SourcesFleetsIdAlertsNoDataAlertLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/alerts/no-data-alert/trigger.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesFleetsIdAlertsNoDataAlertNotificationRoute =
  SourcesFleetsIdAlertsNoDataAlertNotificationRouteImport.update({
    id: '/notification',
    path: '/notification',
    getParentRoute: () => SourcesFleetsIdAlertsNoDataAlertLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/fleets/$id/alerts/no-data-alert/notification.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute =
  SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteImport.update({
    id: '/$app/$tab',
    path: '/$app/$tab',
    getParentRoute: () => SourcesEdgeGatewaysIdMessagesLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/messages/$app/$tab/_layout.lazy').then(
      (d) => d.Route,
    ),
  )
const SourcesEdgeGatewaysIdMessagesAppTabIndexRoute =
  SourcesEdgeGatewaysIdMessagesAppTabIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute,
  } as any).lazy(() =>
    import('./routes/sources/edge-gateways/$id/messages/$app/$tab/index.lazy').then(
      (d) => d.Route,
    ),
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/identity-and-access': typeof IdentityAndAccessLayoutRouteWithChildren
  '/resources': typeof ResourcesLayoutRouteWithChildren
  '/sources': typeof SourcesLayoutRouteWithChildren
  '/storage-hub': typeof StorageHubLayoutRouteWithChildren
  '/uns': typeof UnsLayoutRouteWithChildren
  '/resources/$id': typeof ResourcesIdLayoutRouteWithChildren
  '/storage-hub/capture-storage': typeof StorageHubCaptureStorageLayoutRouteWithChildren
  '/app/$id': typeof AppIdRoute
  '/captain-ai/$chatId': typeof CaptainAiChatIdRoute
  '/admin/': typeof AdminIndexRoute
  '/captain-ai/': typeof CaptainAiIndexRoute
  '/capture/': typeof CaptureIndexRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/identity-and-access/': typeof IdentityAndAccessIndexRoute
  '/login/': typeof LoginIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/sources/': typeof SourcesIndexRoute
  '/storage-hub/': typeof StorageHubIndexRoute
  '/uns/': typeof UnsIndexRoute
  '/identity-and-access/api-tokens/$id': typeof IdentityAndAccessApiTokensIdLayoutRouteWithChildren
  '/identity-and-access/api-tokens/new': typeof IdentityAndAccessApiTokensNewLayoutRouteWithChildren
  '/resources/$id/linked-to': typeof ResourcesIdLinkedToLayoutRouteWithChildren
  '/resources/$id/versions': typeof ResourcesIdVersionsLayoutRouteWithChildren
  '/sources/configurations/$id': typeof SourcesConfigurationsIdLayoutRoute
  '/sources/edge-gateways/$id': typeof SourcesEdgeGatewaysIdLayoutRouteWithChildren
  '/sources/fleets/$id': typeof SourcesFleetsIdLayoutRouteWithChildren
  '/sources/projects/$id': typeof SourcesProjectsIdLayoutRouteWithChildren
  '/resources/$id/general': typeof ResourcesIdGeneralRoute
  '/admin/announcements/': typeof AdminAnnouncementsIndexRoute
  '/admin/cache/': typeof AdminCacheIndexRoute
  '/admin/custom-apps/': typeof AdminCustomAppsIndexRoute
  '/admin/native-apps/': typeof AdminNativeAppsIndexRoute
  '/admin/terms-and-privacy/': typeof AdminTermsAndPrivacyIndexRoute
  '/dashboards/$id/': typeof DashboardsIdIndexRoute
  '/identity-and-access/api-tokens/': typeof IdentityAndAccessApiTokensIndexRoute
  '/identity-and-access/companies/': typeof IdentityAndAccessCompaniesIndexRoute
  '/identity-and-access/groups/': typeof IdentityAndAccessGroupsIndexRoute
  '/identity-and-access/roles/': typeof IdentityAndAccessRolesIndexRoute
  '/identity-and-access/users/': typeof IdentityAndAccessUsersIndexRoute
  '/resources/$id/': typeof ResourcesIdIndexRoute
  '/sources/configurations/': typeof SourcesConfigurationsIndexRoute
  '/sources/edge-gateways/': typeof SourcesEdgeGatewaysIndexRoute
  '/sources/fleets/': typeof SourcesFleetsIndexRoute
  '/sources/projects/': typeof SourcesProjectsIndexRoute
  '/storage-hub/capture-storage/': typeof StorageHubCaptureStorageIndexRoute
  '/uns/data-explorer/': typeof UnsDataExplorerIndexRoute
  '/uns/metadatabundles/': typeof UnsMetadatabundlesIndexRoute
  '/uns/uns-builder/': typeof UnsUnsBuilderIndexRoute
  '/admin/home/': typeof AdminHomeIndexLazyRoute
  '/identity-and-access/home/': typeof IdentityAndAccessHomeIndexLazyRoute
  '/sources/home/': typeof SourcesHomeIndexLazyRoute
  '/uns/home/': typeof UnsHomeIndexLazyRoute
  '/resources/$id/versions/$versionId': typeof ResourcesIdVersionsVersionIdLayoutRouteWithChildren
  '/resources/$id/versions/new': typeof ResourcesIdVersionsNewLayoutRouteWithChildren
  '/sources/edge-gateways/$id/messages': typeof SourcesEdgeGatewaysIdMessagesLayoutRouteWithChildren
  '/sources/fleets/$id/alerts': typeof SourcesFleetsIdAlertsLayoutRouteWithChildren
  '/sources/fleets/$id/cloud-storage': typeof SourcesFleetsIdCloudStorageLayoutRouteWithChildren
  '/sources/projects/$id/reports': typeof SourcesProjectsIdReportsLayoutRouteWithChildren
  '/storage-hub/capture-storage/blob/$id': typeof StorageHubCaptureStorageBlobIdLayoutRouteWithChildren
  '/storage-hub/capture-storage/database/$id': typeof StorageHubCaptureStorageDatabaseIdLayoutRouteWithChildren
  '/identity-and-access/api-tokens/$id/databases': typeof IdentityAndAccessApiTokensIdDatabasesRoute
  '/identity-and-access/api-tokens/$id/general': typeof IdentityAndAccessApiTokensIdGeneralRoute
  '/identity-and-access/api-tokens/$id/permissions': typeof IdentityAndAccessApiTokensIdPermissionsRoute
  '/identity-and-access/api-tokens/new/databases': typeof IdentityAndAccessApiTokensNewDatabasesRoute
  '/identity-and-access/api-tokens/new/general': typeof IdentityAndAccessApiTokensNewGeneralRoute
  '/identity-and-access/api-tokens/new/permissions': typeof IdentityAndAccessApiTokensNewPermissionsRoute
  '/resources/$id/linked-to/edge-gateways': typeof ResourcesIdLinkedToEdgeGatewaysRoute
  '/resources/$id/linked-to/fleets': typeof ResourcesIdLinkedToFleetsRoute
  '/resources/$id/linked-to/projects': typeof ResourcesIdLinkedToProjectsRoute
  '/sources/edge-gateways/$id/alerts': typeof SourcesEdgeGatewaysIdAlertsRoute
  '/sources/edge-gateways/$id/cloud-storage': typeof SourcesEdgeGatewaysIdCloudStorageRoute
  '/sources/edge-gateways/$id/overview': typeof SourcesEdgeGatewaysIdOverviewRoute
  '/sources/edge-gateways/$id/resources': typeof SourcesEdgeGatewaysIdResourcesRoute
  '/sources/edge-gateways/$id/settings': typeof SourcesEdgeGatewaysIdSettingsRoute
  '/sources/edge-gateways/$id/variables': typeof SourcesEdgeGatewaysIdVariablesRoute
  '/resources/$id/linked-to/': typeof ResourcesIdLinkedToIndexRoute
  '/resources/$id/versions/': typeof ResourcesIdVersionsIndexRoute
  '/sources/edge-gateways/$id/': typeof SourcesEdgeGatewaysIdIndexRoute
  '/sources/fleets/$id/': typeof SourcesFleetsIdIndexRoute
  '/sources/projects/$id/': typeof SourcesProjectsIdIndexRoute
  '/storage-hub/capture-storage/blob/': typeof StorageHubCaptureStorageBlobIndexRoute
  '/storage-hub/capture-storage/database/': typeof StorageHubCaptureStorageDatabaseIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert': typeof SourcesFleetsIdAlertsNoDataAlertLayoutRouteWithChildren
  '/resources/$id/versions/$versionId/general': typeof ResourcesIdVersionsVersionIdGeneralRoute
  '/resources/$id/versions/$versionId/variables': typeof ResourcesIdVersionsVersionIdVariablesRoute
  '/resources/$id/versions/new/general': typeof ResourcesIdVersionsNewGeneralRoute
  '/resources/$id/versions/new/variables': typeof ResourcesIdVersionsNewVariablesRoute
  '/storage-hub/capture-storage/blob/$id/settings': typeof StorageHubCaptureStorageBlobIdSettingsRoute
  '/storage-hub/capture-storage/database/$id/measurements': typeof StorageHubCaptureStorageDatabaseIdMeasurementsRoute
  '/storage-hub/capture-storage/database/$id/permissions': typeof StorageHubCaptureStorageDatabaseIdPermissionsRoute
  '/storage-hub/capture-storage/database/$id/settings': typeof StorageHubCaptureStorageDatabaseIdSettingsRoute
  '/resources/$id/versions/$versionId/': typeof ResourcesIdVersionsVersionIdIndexRoute
  '/sources/edge-gateways/$id/messages/': typeof SourcesEdgeGatewaysIdMessagesIndexRoute
  '/sources/fleets/$id/alerts/': typeof SourcesFleetsIdAlertsIndexRoute
  '/sources/fleets/$id/cloud-storage/': typeof SourcesFleetsIdCloudStorageIndexRoute
  '/sources/fleets/$id/configurations/': typeof SourcesFleetsIdConfigurationsIndexRoute
  '/sources/fleets/$id/dashboards/': typeof SourcesFleetsIdDashboardsIndexRoute
  '/sources/fleets/$id/edge-gateways/': typeof SourcesFleetsIdEdgeGatewaysIndexRoute
  '/sources/fleets/$id/general/': typeof SourcesFleetsIdGeneralIndexRoute
  '/sources/fleets/$id/reports/': typeof SourcesFleetsIdReportsIndexRoute
  '/sources/fleets/$id/resources/': typeof SourcesFleetsIdResourcesIndexRoute
  '/sources/projects/$id/dashboards/': typeof SourcesProjectsIdDashboardsIndexRoute
  '/sources/projects/$id/edge-gateways/': typeof SourcesProjectsIdEdgeGatewaysIndexRoute
  '/sources/projects/$id/general/': typeof SourcesProjectsIdGeneralIndexRoute
  '/sources/projects/$id/reports/': typeof SourcesProjectsIdReportsIndexRoute
  '/sources/projects/$id/resources/': typeof SourcesProjectsIdResourcesIndexRoute
  '/storage-hub/capture-storage/blob/$id/': typeof StorageHubCaptureStorageBlobIdIndexRoute
  '/storage-hub/capture-storage/database/$id/': typeof StorageHubCaptureStorageDatabaseIdIndexRoute
  '/sources/edge-gateways/$id/messages/$app/$tab': typeof SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteWithChildren
  '/sources/fleets/$id/alerts/no-data-alert/notification': typeof SourcesFleetsIdAlertsNoDataAlertNotificationRoute
  '/sources/fleets/$id/alerts/no-data-alert/trigger': typeof SourcesFleetsIdAlertsNoDataAlertTriggerRoute
  '/sources/edge-gateways/$id/messages/$app/': typeof SourcesEdgeGatewaysIdMessagesAppIndexRoute
  '/sources/fleets/$id/alerts/$alertId/': typeof SourcesFleetsIdAlertsAlertIdIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert/': typeof SourcesFleetsIdAlertsNoDataAlertIndexRoute
  '/sources/fleets/$id/cloud-storage/databases/': typeof SourcesFleetsIdCloudStorageDatabasesIndexRoute
  '/sources/fleets/$id/cloud-storage/parent-db-sync/': typeof SourcesFleetsIdCloudStorageParentDbSyncIndexRoute
  '/sources/projects/$id/reports/$reportConfigId/': typeof SourcesProjectsIdReportsReportConfigIdIndexRoute
  '/sources/edge-gateways/$id/messages/$app/$tab/': typeof SourcesEdgeGatewaysIdMessagesAppTabIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/app/$id': typeof AppIdRoute
  '/captain-ai/$chatId': typeof CaptainAiChatIdRoute
  '/admin': typeof AdminIndexRoute
  '/captain-ai': typeof CaptainAiIndexRoute
  '/capture': typeof CaptureIndexRoute
  '/dashboards': typeof DashboardsIndexRoute
  '/identity-and-access': typeof IdentityAndAccessIndexRoute
  '/login': typeof LoginIndexRoute
  '/resources': typeof ResourcesIndexRoute
  '/sources': typeof SourcesIndexRoute
  '/storage-hub': typeof StorageHubIndexRoute
  '/uns': typeof UnsIndexRoute
  '/identity-and-access/api-tokens/$id': typeof IdentityAndAccessApiTokensIdLayoutRouteWithChildren
  '/identity-and-access/api-tokens/new': typeof IdentityAndAccessApiTokensNewLayoutRouteWithChildren
  '/sources/configurations/$id': typeof SourcesConfigurationsIdLayoutRoute
  '/resources/$id/general': typeof ResourcesIdGeneralRoute
  '/admin/announcements': typeof AdminAnnouncementsIndexRoute
  '/admin/cache': typeof AdminCacheIndexRoute
  '/admin/custom-apps': typeof AdminCustomAppsIndexRoute
  '/admin/native-apps': typeof AdminNativeAppsIndexRoute
  '/admin/terms-and-privacy': typeof AdminTermsAndPrivacyIndexRoute
  '/dashboards/$id': typeof DashboardsIdIndexRoute
  '/identity-and-access/api-tokens': typeof IdentityAndAccessApiTokensIndexRoute
  '/identity-and-access/companies': typeof IdentityAndAccessCompaniesIndexRoute
  '/identity-and-access/groups': typeof IdentityAndAccessGroupsIndexRoute
  '/identity-and-access/roles': typeof IdentityAndAccessRolesIndexRoute
  '/identity-and-access/users': typeof IdentityAndAccessUsersIndexRoute
  '/resources/$id': typeof ResourcesIdIndexRoute
  '/sources/configurations': typeof SourcesConfigurationsIndexRoute
  '/sources/edge-gateways': typeof SourcesEdgeGatewaysIndexRoute
  '/sources/fleets': typeof SourcesFleetsIndexRoute
  '/sources/projects': typeof SourcesProjectsIndexRoute
  '/storage-hub/capture-storage': typeof StorageHubCaptureStorageIndexRoute
  '/uns/data-explorer': typeof UnsDataExplorerIndexRoute
  '/uns/metadatabundles': typeof UnsMetadatabundlesIndexRoute
  '/uns/uns-builder': typeof UnsUnsBuilderIndexRoute
  '/admin/home': typeof AdminHomeIndexLazyRoute
  '/identity-and-access/home': typeof IdentityAndAccessHomeIndexLazyRoute
  '/sources/home': typeof SourcesHomeIndexLazyRoute
  '/uns/home': typeof UnsHomeIndexLazyRoute
  '/resources/$id/versions/new': typeof ResourcesIdVersionsNewLayoutRouteWithChildren
  '/identity-and-access/api-tokens/$id/databases': typeof IdentityAndAccessApiTokensIdDatabasesRoute
  '/identity-and-access/api-tokens/$id/general': typeof IdentityAndAccessApiTokensIdGeneralRoute
  '/identity-and-access/api-tokens/$id/permissions': typeof IdentityAndAccessApiTokensIdPermissionsRoute
  '/identity-and-access/api-tokens/new/databases': typeof IdentityAndAccessApiTokensNewDatabasesRoute
  '/identity-and-access/api-tokens/new/general': typeof IdentityAndAccessApiTokensNewGeneralRoute
  '/identity-and-access/api-tokens/new/permissions': typeof IdentityAndAccessApiTokensNewPermissionsRoute
  '/resources/$id/linked-to/edge-gateways': typeof ResourcesIdLinkedToEdgeGatewaysRoute
  '/resources/$id/linked-to/fleets': typeof ResourcesIdLinkedToFleetsRoute
  '/resources/$id/linked-to/projects': typeof ResourcesIdLinkedToProjectsRoute
  '/sources/edge-gateways/$id/alerts': typeof SourcesEdgeGatewaysIdAlertsRoute
  '/sources/edge-gateways/$id/cloud-storage': typeof SourcesEdgeGatewaysIdCloudStorageRoute
  '/sources/edge-gateways/$id/overview': typeof SourcesEdgeGatewaysIdOverviewRoute
  '/sources/edge-gateways/$id/resources': typeof SourcesEdgeGatewaysIdResourcesRoute
  '/sources/edge-gateways/$id/settings': typeof SourcesEdgeGatewaysIdSettingsRoute
  '/sources/edge-gateways/$id/variables': typeof SourcesEdgeGatewaysIdVariablesRoute
  '/resources/$id/linked-to': typeof ResourcesIdLinkedToIndexRoute
  '/resources/$id/versions': typeof ResourcesIdVersionsIndexRoute
  '/sources/edge-gateways/$id': typeof SourcesEdgeGatewaysIdIndexRoute
  '/sources/fleets/$id': typeof SourcesFleetsIdIndexRoute
  '/sources/projects/$id': typeof SourcesProjectsIdIndexRoute
  '/storage-hub/capture-storage/blob': typeof StorageHubCaptureStorageBlobIndexRoute
  '/storage-hub/capture-storage/database': typeof StorageHubCaptureStorageDatabaseIndexRoute
  '/resources/$id/versions/$versionId/general': typeof ResourcesIdVersionsVersionIdGeneralRoute
  '/resources/$id/versions/$versionId/variables': typeof ResourcesIdVersionsVersionIdVariablesRoute
  '/resources/$id/versions/new/general': typeof ResourcesIdVersionsNewGeneralRoute
  '/resources/$id/versions/new/variables': typeof ResourcesIdVersionsNewVariablesRoute
  '/storage-hub/capture-storage/blob/$id/settings': typeof StorageHubCaptureStorageBlobIdSettingsRoute
  '/storage-hub/capture-storage/database/$id/measurements': typeof StorageHubCaptureStorageDatabaseIdMeasurementsRoute
  '/storage-hub/capture-storage/database/$id/permissions': typeof StorageHubCaptureStorageDatabaseIdPermissionsRoute
  '/storage-hub/capture-storage/database/$id/settings': typeof StorageHubCaptureStorageDatabaseIdSettingsRoute
  '/resources/$id/versions/$versionId': typeof ResourcesIdVersionsVersionIdIndexRoute
  '/sources/edge-gateways/$id/messages': typeof SourcesEdgeGatewaysIdMessagesIndexRoute
  '/sources/fleets/$id/alerts': typeof SourcesFleetsIdAlertsIndexRoute
  '/sources/fleets/$id/cloud-storage': typeof SourcesFleetsIdCloudStorageIndexRoute
  '/sources/fleets/$id/configurations': typeof SourcesFleetsIdConfigurationsIndexRoute
  '/sources/fleets/$id/dashboards': typeof SourcesFleetsIdDashboardsIndexRoute
  '/sources/fleets/$id/edge-gateways': typeof SourcesFleetsIdEdgeGatewaysIndexRoute
  '/sources/fleets/$id/general': typeof SourcesFleetsIdGeneralIndexRoute
  '/sources/fleets/$id/reports': typeof SourcesFleetsIdReportsIndexRoute
  '/sources/fleets/$id/resources': typeof SourcesFleetsIdResourcesIndexRoute
  '/sources/projects/$id/dashboards': typeof SourcesProjectsIdDashboardsIndexRoute
  '/sources/projects/$id/edge-gateways': typeof SourcesProjectsIdEdgeGatewaysIndexRoute
  '/sources/projects/$id/general': typeof SourcesProjectsIdGeneralIndexRoute
  '/sources/projects/$id/reports': typeof SourcesProjectsIdReportsIndexRoute
  '/sources/projects/$id/resources': typeof SourcesProjectsIdResourcesIndexRoute
  '/storage-hub/capture-storage/blob/$id': typeof StorageHubCaptureStorageBlobIdIndexRoute
  '/storage-hub/capture-storage/database/$id': typeof StorageHubCaptureStorageDatabaseIdIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert/notification': typeof SourcesFleetsIdAlertsNoDataAlertNotificationRoute
  '/sources/fleets/$id/alerts/no-data-alert/trigger': typeof SourcesFleetsIdAlertsNoDataAlertTriggerRoute
  '/sources/edge-gateways/$id/messages/$app': typeof SourcesEdgeGatewaysIdMessagesAppIndexRoute
  '/sources/fleets/$id/alerts/$alertId': typeof SourcesFleetsIdAlertsAlertIdIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert': typeof SourcesFleetsIdAlertsNoDataAlertIndexRoute
  '/sources/fleets/$id/cloud-storage/databases': typeof SourcesFleetsIdCloudStorageDatabasesIndexRoute
  '/sources/fleets/$id/cloud-storage/parent-db-sync': typeof SourcesFleetsIdCloudStorageParentDbSyncIndexRoute
  '/sources/projects/$id/reports/$reportConfigId': typeof SourcesProjectsIdReportsReportConfigIdIndexRoute
  '/sources/edge-gateways/$id/messages/$app/$tab': typeof SourcesEdgeGatewaysIdMessagesAppTabIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/admin': typeof AdminLayoutRouteWithChildren
  '/identity-and-access': typeof IdentityAndAccessLayoutRouteWithChildren
  '/resources': typeof ResourcesLayoutRouteWithChildren
  '/sources': typeof SourcesLayoutRouteWithChildren
  '/storage-hub': typeof StorageHubLayoutRouteWithChildren
  '/uns': typeof UnsLayoutRouteWithChildren
  '/resources/$id': typeof ResourcesIdLayoutRouteWithChildren
  '/storage-hub/capture-storage': typeof StorageHubCaptureStorageLayoutRouteWithChildren
  '/app/$id': typeof AppIdRoute
  '/captain-ai/$chatId': typeof CaptainAiChatIdRoute
  '/admin/': typeof AdminIndexRoute
  '/captain-ai/': typeof CaptainAiIndexRoute
  '/capture/': typeof CaptureIndexRoute
  '/dashboards/': typeof DashboardsIndexRoute
  '/identity-and-access/': typeof IdentityAndAccessIndexRoute
  '/login/': typeof LoginIndexRoute
  '/resources/': typeof ResourcesIndexRoute
  '/sources/': typeof SourcesIndexRoute
  '/storage-hub/': typeof StorageHubIndexRoute
  '/uns/': typeof UnsIndexRoute
  '/identity-and-access/api-tokens/$id': typeof IdentityAndAccessApiTokensIdLayoutRouteWithChildren
  '/identity-and-access/api-tokens/new': typeof IdentityAndAccessApiTokensNewLayoutRouteWithChildren
  '/resources/$id/linked-to': typeof ResourcesIdLinkedToLayoutRouteWithChildren
  '/resources/$id/versions': typeof ResourcesIdVersionsLayoutRouteWithChildren
  '/sources/configurations/$id': typeof SourcesConfigurationsIdLayoutRoute
  '/sources/edge-gateways/$id': typeof SourcesEdgeGatewaysIdLayoutRouteWithChildren
  '/sources/fleets/$id': typeof SourcesFleetsIdLayoutRouteWithChildren
  '/sources/projects/$id': typeof SourcesProjectsIdLayoutRouteWithChildren
  '/resources/$id/general': typeof ResourcesIdGeneralRoute
  '/admin/announcements/': typeof AdminAnnouncementsIndexRoute
  '/admin/cache/': typeof AdminCacheIndexRoute
  '/admin/custom-apps/': typeof AdminCustomAppsIndexRoute
  '/admin/native-apps/': typeof AdminNativeAppsIndexRoute
  '/admin/terms-and-privacy/': typeof AdminTermsAndPrivacyIndexRoute
  '/dashboards/$id/': typeof DashboardsIdIndexRoute
  '/identity-and-access/api-tokens/': typeof IdentityAndAccessApiTokensIndexRoute
  '/identity-and-access/companies/': typeof IdentityAndAccessCompaniesIndexRoute
  '/identity-and-access/groups/': typeof IdentityAndAccessGroupsIndexRoute
  '/identity-and-access/roles/': typeof IdentityAndAccessRolesIndexRoute
  '/identity-and-access/users/': typeof IdentityAndAccessUsersIndexRoute
  '/resources/$id/': typeof ResourcesIdIndexRoute
  '/sources/configurations/': typeof SourcesConfigurationsIndexRoute
  '/sources/edge-gateways/': typeof SourcesEdgeGatewaysIndexRoute
  '/sources/fleets/': typeof SourcesFleetsIndexRoute
  '/sources/projects/': typeof SourcesProjectsIndexRoute
  '/storage-hub/capture-storage/': typeof StorageHubCaptureStorageIndexRoute
  '/uns/data-explorer/': typeof UnsDataExplorerIndexRoute
  '/uns/metadatabundles/': typeof UnsMetadatabundlesIndexRoute
  '/uns/uns-builder/': typeof UnsUnsBuilderIndexRoute
  '/admin/home/': typeof AdminHomeIndexLazyRoute
  '/identity-and-access/home/': typeof IdentityAndAccessHomeIndexLazyRoute
  '/sources/home/': typeof SourcesHomeIndexLazyRoute
  '/uns/home/': typeof UnsHomeIndexLazyRoute
  '/resources/$id/versions/$versionId': typeof ResourcesIdVersionsVersionIdLayoutRouteWithChildren
  '/resources/$id/versions/new': typeof ResourcesIdVersionsNewLayoutRouteWithChildren
  '/sources/edge-gateways/$id/messages': typeof SourcesEdgeGatewaysIdMessagesLayoutRouteWithChildren
  '/sources/fleets/$id/alerts': typeof SourcesFleetsIdAlertsLayoutRouteWithChildren
  '/sources/fleets/$id/cloud-storage': typeof SourcesFleetsIdCloudStorageLayoutRouteWithChildren
  '/sources/projects/$id/reports': typeof SourcesProjectsIdReportsLayoutRouteWithChildren
  '/storage-hub/capture-storage/blob/$id': typeof StorageHubCaptureStorageBlobIdLayoutRouteWithChildren
  '/storage-hub/capture-storage/database/$id': typeof StorageHubCaptureStorageDatabaseIdLayoutRouteWithChildren
  '/identity-and-access/api-tokens/$id/databases': typeof IdentityAndAccessApiTokensIdDatabasesRoute
  '/identity-and-access/api-tokens/$id/general': typeof IdentityAndAccessApiTokensIdGeneralRoute
  '/identity-and-access/api-tokens/$id/permissions': typeof IdentityAndAccessApiTokensIdPermissionsRoute
  '/identity-and-access/api-tokens/new/databases': typeof IdentityAndAccessApiTokensNewDatabasesRoute
  '/identity-and-access/api-tokens/new/general': typeof IdentityAndAccessApiTokensNewGeneralRoute
  '/identity-and-access/api-tokens/new/permissions': typeof IdentityAndAccessApiTokensNewPermissionsRoute
  '/resources/$id/linked-to/edge-gateways': typeof ResourcesIdLinkedToEdgeGatewaysRoute
  '/resources/$id/linked-to/fleets': typeof ResourcesIdLinkedToFleetsRoute
  '/resources/$id/linked-to/projects': typeof ResourcesIdLinkedToProjectsRoute
  '/sources/edge-gateways/$id/alerts': typeof SourcesEdgeGatewaysIdAlertsRoute
  '/sources/edge-gateways/$id/cloud-storage': typeof SourcesEdgeGatewaysIdCloudStorageRoute
  '/sources/edge-gateways/$id/overview': typeof SourcesEdgeGatewaysIdOverviewRoute
  '/sources/edge-gateways/$id/resources': typeof SourcesEdgeGatewaysIdResourcesRoute
  '/sources/edge-gateways/$id/settings': typeof SourcesEdgeGatewaysIdSettingsRoute
  '/sources/edge-gateways/$id/variables': typeof SourcesEdgeGatewaysIdVariablesRoute
  '/resources/$id/linked-to/': typeof ResourcesIdLinkedToIndexRoute
  '/resources/$id/versions/': typeof ResourcesIdVersionsIndexRoute
  '/sources/edge-gateways/$id/': typeof SourcesEdgeGatewaysIdIndexRoute
  '/sources/fleets/$id/': typeof SourcesFleetsIdIndexRoute
  '/sources/projects/$id/': typeof SourcesProjectsIdIndexRoute
  '/storage-hub/capture-storage/blob/': typeof StorageHubCaptureStorageBlobIndexRoute
  '/storage-hub/capture-storage/database/': typeof StorageHubCaptureStorageDatabaseIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert': typeof SourcesFleetsIdAlertsNoDataAlertLayoutRouteWithChildren
  '/resources/$id/versions/$versionId/general': typeof ResourcesIdVersionsVersionIdGeneralRoute
  '/resources/$id/versions/$versionId/variables': typeof ResourcesIdVersionsVersionIdVariablesRoute
  '/resources/$id/versions/new/general': typeof ResourcesIdVersionsNewGeneralRoute
  '/resources/$id/versions/new/variables': typeof ResourcesIdVersionsNewVariablesRoute
  '/storage-hub/capture-storage/blob/$id/settings': typeof StorageHubCaptureStorageBlobIdSettingsRoute
  '/storage-hub/capture-storage/database/$id/measurements': typeof StorageHubCaptureStorageDatabaseIdMeasurementsRoute
  '/storage-hub/capture-storage/database/$id/permissions': typeof StorageHubCaptureStorageDatabaseIdPermissionsRoute
  '/storage-hub/capture-storage/database/$id/settings': typeof StorageHubCaptureStorageDatabaseIdSettingsRoute
  '/resources/$id/versions/$versionId/': typeof ResourcesIdVersionsVersionIdIndexRoute
  '/sources/edge-gateways/$id/messages/': typeof SourcesEdgeGatewaysIdMessagesIndexRoute
  '/sources/fleets/$id/alerts/': typeof SourcesFleetsIdAlertsIndexRoute
  '/sources/fleets/$id/cloud-storage/': typeof SourcesFleetsIdCloudStorageIndexRoute
  '/sources/fleets/$id/configurations/': typeof SourcesFleetsIdConfigurationsIndexRoute
  '/sources/fleets/$id/dashboards/': typeof SourcesFleetsIdDashboardsIndexRoute
  '/sources/fleets/$id/edge-gateways/': typeof SourcesFleetsIdEdgeGatewaysIndexRoute
  '/sources/fleets/$id/general/': typeof SourcesFleetsIdGeneralIndexRoute
  '/sources/fleets/$id/reports/': typeof SourcesFleetsIdReportsIndexRoute
  '/sources/fleets/$id/resources/': typeof SourcesFleetsIdResourcesIndexRoute
  '/sources/projects/$id/dashboards/': typeof SourcesProjectsIdDashboardsIndexRoute
  '/sources/projects/$id/edge-gateways/': typeof SourcesProjectsIdEdgeGatewaysIndexRoute
  '/sources/projects/$id/general/': typeof SourcesProjectsIdGeneralIndexRoute
  '/sources/projects/$id/reports/': typeof SourcesProjectsIdReportsIndexRoute
  '/sources/projects/$id/resources/': typeof SourcesProjectsIdResourcesIndexRoute
  '/storage-hub/capture-storage/blob/$id/': typeof StorageHubCaptureStorageBlobIdIndexRoute
  '/storage-hub/capture-storage/database/$id/': typeof StorageHubCaptureStorageDatabaseIdIndexRoute
  '/sources/edge-gateways/$id/messages/$app/$tab': typeof SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteWithChildren
  '/sources/fleets/$id/alerts/no-data-alert/notification': typeof SourcesFleetsIdAlertsNoDataAlertNotificationRoute
  '/sources/fleets/$id/alerts/no-data-alert/trigger': typeof SourcesFleetsIdAlertsNoDataAlertTriggerRoute
  '/sources/edge-gateways/$id/messages/$app/': typeof SourcesEdgeGatewaysIdMessagesAppIndexRoute
  '/sources/fleets/$id/alerts/$alertId/': typeof SourcesFleetsIdAlertsAlertIdIndexRoute
  '/sources/fleets/$id/alerts/no-data-alert/': typeof SourcesFleetsIdAlertsNoDataAlertIndexRoute
  '/sources/fleets/$id/cloud-storage/databases/': typeof SourcesFleetsIdCloudStorageDatabasesIndexRoute
  '/sources/fleets/$id/cloud-storage/parent-db-sync/': typeof SourcesFleetsIdCloudStorageParentDbSyncIndexRoute
  '/sources/projects/$id/reports/$reportConfigId/': typeof SourcesProjectsIdReportsReportConfigIdIndexRoute
  '/sources/edge-gateways/$id/messages/$app/$tab/': typeof SourcesEdgeGatewaysIdMessagesAppTabIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/identity-and-access'
    | '/resources'
    | '/sources'
    | '/storage-hub'
    | '/uns'
    | '/resources/$id'
    | '/storage-hub/capture-storage'
    | '/app/$id'
    | '/captain-ai/$chatId'
    | '/admin/'
    | '/captain-ai/'
    | '/capture/'
    | '/dashboards/'
    | '/identity-and-access/'
    | '/login/'
    | '/resources/'
    | '/sources/'
    | '/storage-hub/'
    | '/uns/'
    | '/identity-and-access/api-tokens/$id'
    | '/identity-and-access/api-tokens/new'
    | '/resources/$id/linked-to'
    | '/resources/$id/versions'
    | '/sources/configurations/$id'
    | '/sources/edge-gateways/$id'
    | '/sources/fleets/$id'
    | '/sources/projects/$id'
    | '/resources/$id/general'
    | '/admin/announcements/'
    | '/admin/cache/'
    | '/admin/custom-apps/'
    | '/admin/native-apps/'
    | '/admin/terms-and-privacy/'
    | '/dashboards/$id/'
    | '/identity-and-access/api-tokens/'
    | '/identity-and-access/companies/'
    | '/identity-and-access/groups/'
    | '/identity-and-access/roles/'
    | '/identity-and-access/users/'
    | '/resources/$id/'
    | '/sources/configurations/'
    | '/sources/edge-gateways/'
    | '/sources/fleets/'
    | '/sources/projects/'
    | '/storage-hub/capture-storage/'
    | '/uns/data-explorer/'
    | '/uns/metadatabundles/'
    | '/uns/uns-builder/'
    | '/admin/home/'
    | '/identity-and-access/home/'
    | '/sources/home/'
    | '/uns/home/'
    | '/resources/$id/versions/$versionId'
    | '/resources/$id/versions/new'
    | '/sources/edge-gateways/$id/messages'
    | '/sources/fleets/$id/alerts'
    | '/sources/fleets/$id/cloud-storage'
    | '/sources/projects/$id/reports'
    | '/storage-hub/capture-storage/blob/$id'
    | '/storage-hub/capture-storage/database/$id'
    | '/identity-and-access/api-tokens/$id/databases'
    | '/identity-and-access/api-tokens/$id/general'
    | '/identity-and-access/api-tokens/$id/permissions'
    | '/identity-and-access/api-tokens/new/databases'
    | '/identity-and-access/api-tokens/new/general'
    | '/identity-and-access/api-tokens/new/permissions'
    | '/resources/$id/linked-to/edge-gateways'
    | '/resources/$id/linked-to/fleets'
    | '/resources/$id/linked-to/projects'
    | '/sources/edge-gateways/$id/alerts'
    | '/sources/edge-gateways/$id/cloud-storage'
    | '/sources/edge-gateways/$id/overview'
    | '/sources/edge-gateways/$id/resources'
    | '/sources/edge-gateways/$id/settings'
    | '/sources/edge-gateways/$id/variables'
    | '/resources/$id/linked-to/'
    | '/resources/$id/versions/'
    | '/sources/edge-gateways/$id/'
    | '/sources/fleets/$id/'
    | '/sources/projects/$id/'
    | '/storage-hub/capture-storage/blob/'
    | '/storage-hub/capture-storage/database/'
    | '/sources/fleets/$id/alerts/no-data-alert'
    | '/resources/$id/versions/$versionId/general'
    | '/resources/$id/versions/$versionId/variables'
    | '/resources/$id/versions/new/general'
    | '/resources/$id/versions/new/variables'
    | '/storage-hub/capture-storage/blob/$id/settings'
    | '/storage-hub/capture-storage/database/$id/measurements'
    | '/storage-hub/capture-storage/database/$id/permissions'
    | '/storage-hub/capture-storage/database/$id/settings'
    | '/resources/$id/versions/$versionId/'
    | '/sources/edge-gateways/$id/messages/'
    | '/sources/fleets/$id/alerts/'
    | '/sources/fleets/$id/cloud-storage/'
    | '/sources/fleets/$id/configurations/'
    | '/sources/fleets/$id/dashboards/'
    | '/sources/fleets/$id/edge-gateways/'
    | '/sources/fleets/$id/general/'
    | '/sources/fleets/$id/reports/'
    | '/sources/fleets/$id/resources/'
    | '/sources/projects/$id/dashboards/'
    | '/sources/projects/$id/edge-gateways/'
    | '/sources/projects/$id/general/'
    | '/sources/projects/$id/reports/'
    | '/sources/projects/$id/resources/'
    | '/storage-hub/capture-storage/blob/$id/'
    | '/storage-hub/capture-storage/database/$id/'
    | '/sources/edge-gateways/$id/messages/$app/$tab'
    | '/sources/fleets/$id/alerts/no-data-alert/notification'
    | '/sources/fleets/$id/alerts/no-data-alert/trigger'
    | '/sources/edge-gateways/$id/messages/$app/'
    | '/sources/fleets/$id/alerts/$alertId/'
    | '/sources/fleets/$id/alerts/no-data-alert/'
    | '/sources/fleets/$id/cloud-storage/databases/'
    | '/sources/fleets/$id/cloud-storage/parent-db-sync/'
    | '/sources/projects/$id/reports/$reportConfigId/'
    | '/sources/edge-gateways/$id/messages/$app/$tab/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app/$id'
    | '/captain-ai/$chatId'
    | '/admin'
    | '/captain-ai'
    | '/capture'
    | '/dashboards'
    | '/identity-and-access'
    | '/login'
    | '/resources'
    | '/sources'
    | '/storage-hub'
    | '/uns'
    | '/identity-and-access/api-tokens/$id'
    | '/identity-and-access/api-tokens/new'
    | '/sources/configurations/$id'
    | '/resources/$id/general'
    | '/admin/announcements'
    | '/admin/cache'
    | '/admin/custom-apps'
    | '/admin/native-apps'
    | '/admin/terms-and-privacy'
    | '/dashboards/$id'
    | '/identity-and-access/api-tokens'
    | '/identity-and-access/companies'
    | '/identity-and-access/groups'
    | '/identity-and-access/roles'
    | '/identity-and-access/users'
    | '/resources/$id'
    | '/sources/configurations'
    | '/sources/edge-gateways'
    | '/sources/fleets'
    | '/sources/projects'
    | '/storage-hub/capture-storage'
    | '/uns/data-explorer'
    | '/uns/metadatabundles'
    | '/uns/uns-builder'
    | '/admin/home'
    | '/identity-and-access/home'
    | '/sources/home'
    | '/uns/home'
    | '/resources/$id/versions/new'
    | '/identity-and-access/api-tokens/$id/databases'
    | '/identity-and-access/api-tokens/$id/general'
    | '/identity-and-access/api-tokens/$id/permissions'
    | '/identity-and-access/api-tokens/new/databases'
    | '/identity-and-access/api-tokens/new/general'
    | '/identity-and-access/api-tokens/new/permissions'
    | '/resources/$id/linked-to/edge-gateways'
    | '/resources/$id/linked-to/fleets'
    | '/resources/$id/linked-to/projects'
    | '/sources/edge-gateways/$id/alerts'
    | '/sources/edge-gateways/$id/cloud-storage'
    | '/sources/edge-gateways/$id/overview'
    | '/sources/edge-gateways/$id/resources'
    | '/sources/edge-gateways/$id/settings'
    | '/sources/edge-gateways/$id/variables'
    | '/resources/$id/linked-to'
    | '/resources/$id/versions'
    | '/sources/edge-gateways/$id'
    | '/sources/fleets/$id'
    | '/sources/projects/$id'
    | '/storage-hub/capture-storage/blob'
    | '/storage-hub/capture-storage/database'
    | '/resources/$id/versions/$versionId/general'
    | '/resources/$id/versions/$versionId/variables'
    | '/resources/$id/versions/new/general'
    | '/resources/$id/versions/new/variables'
    | '/storage-hub/capture-storage/blob/$id/settings'
    | '/storage-hub/capture-storage/database/$id/measurements'
    | '/storage-hub/capture-storage/database/$id/permissions'
    | '/storage-hub/capture-storage/database/$id/settings'
    | '/resources/$id/versions/$versionId'
    | '/sources/edge-gateways/$id/messages'
    | '/sources/fleets/$id/alerts'
    | '/sources/fleets/$id/cloud-storage'
    | '/sources/fleets/$id/configurations'
    | '/sources/fleets/$id/dashboards'
    | '/sources/fleets/$id/edge-gateways'
    | '/sources/fleets/$id/general'
    | '/sources/fleets/$id/reports'
    | '/sources/fleets/$id/resources'
    | '/sources/projects/$id/dashboards'
    | '/sources/projects/$id/edge-gateways'
    | '/sources/projects/$id/general'
    | '/sources/projects/$id/reports'
    | '/sources/projects/$id/resources'
    | '/storage-hub/capture-storage/blob/$id'
    | '/storage-hub/capture-storage/database/$id'
    | '/sources/fleets/$id/alerts/no-data-alert/notification'
    | '/sources/fleets/$id/alerts/no-data-alert/trigger'
    | '/sources/edge-gateways/$id/messages/$app'
    | '/sources/fleets/$id/alerts/$alertId'
    | '/sources/fleets/$id/alerts/no-data-alert'
    | '/sources/fleets/$id/cloud-storage/databases'
    | '/sources/fleets/$id/cloud-storage/parent-db-sync'
    | '/sources/projects/$id/reports/$reportConfigId'
    | '/sources/edge-gateways/$id/messages/$app/$tab'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/identity-and-access'
    | '/resources'
    | '/sources'
    | '/storage-hub'
    | '/uns'
    | '/resources/$id'
    | '/storage-hub/capture-storage'
    | '/app/$id'
    | '/captain-ai/$chatId'
    | '/admin/'
    | '/captain-ai/'
    | '/capture/'
    | '/dashboards/'
    | '/identity-and-access/'
    | '/login/'
    | '/resources/'
    | '/sources/'
    | '/storage-hub/'
    | '/uns/'
    | '/identity-and-access/api-tokens/$id'
    | '/identity-and-access/api-tokens/new'
    | '/resources/$id/linked-to'
    | '/resources/$id/versions'
    | '/sources/configurations/$id'
    | '/sources/edge-gateways/$id'
    | '/sources/fleets/$id'
    | '/sources/projects/$id'
    | '/resources/$id/general'
    | '/admin/announcements/'
    | '/admin/cache/'
    | '/admin/custom-apps/'
    | '/admin/native-apps/'
    | '/admin/terms-and-privacy/'
    | '/dashboards/$id/'
    | '/identity-and-access/api-tokens/'
    | '/identity-and-access/companies/'
    | '/identity-and-access/groups/'
    | '/identity-and-access/roles/'
    | '/identity-and-access/users/'
    | '/resources/$id/'
    | '/sources/configurations/'
    | '/sources/edge-gateways/'
    | '/sources/fleets/'
    | '/sources/projects/'
    | '/storage-hub/capture-storage/'
    | '/uns/data-explorer/'
    | '/uns/metadatabundles/'
    | '/uns/uns-builder/'
    | '/admin/home/'
    | '/identity-and-access/home/'
    | '/sources/home/'
    | '/uns/home/'
    | '/resources/$id/versions/$versionId'
    | '/resources/$id/versions/new'
    | '/sources/edge-gateways/$id/messages'
    | '/sources/fleets/$id/alerts'
    | '/sources/fleets/$id/cloud-storage'
    | '/sources/projects/$id/reports'
    | '/storage-hub/capture-storage/blob/$id'
    | '/storage-hub/capture-storage/database/$id'
    | '/identity-and-access/api-tokens/$id/databases'
    | '/identity-and-access/api-tokens/$id/general'
    | '/identity-and-access/api-tokens/$id/permissions'
    | '/identity-and-access/api-tokens/new/databases'
    | '/identity-and-access/api-tokens/new/general'
    | '/identity-and-access/api-tokens/new/permissions'
    | '/resources/$id/linked-to/edge-gateways'
    | '/resources/$id/linked-to/fleets'
    | '/resources/$id/linked-to/projects'
    | '/sources/edge-gateways/$id/alerts'
    | '/sources/edge-gateways/$id/cloud-storage'
    | '/sources/edge-gateways/$id/overview'
    | '/sources/edge-gateways/$id/resources'
    | '/sources/edge-gateways/$id/settings'
    | '/sources/edge-gateways/$id/variables'
    | '/resources/$id/linked-to/'
    | '/resources/$id/versions/'
    | '/sources/edge-gateways/$id/'
    | '/sources/fleets/$id/'
    | '/sources/projects/$id/'
    | '/storage-hub/capture-storage/blob/'
    | '/storage-hub/capture-storage/database/'
    | '/sources/fleets/$id/alerts/no-data-alert'
    | '/resources/$id/versions/$versionId/general'
    | '/resources/$id/versions/$versionId/variables'
    | '/resources/$id/versions/new/general'
    | '/resources/$id/versions/new/variables'
    | '/storage-hub/capture-storage/blob/$id/settings'
    | '/storage-hub/capture-storage/database/$id/measurements'
    | '/storage-hub/capture-storage/database/$id/permissions'
    | '/storage-hub/capture-storage/database/$id/settings'
    | '/resources/$id/versions/$versionId/'
    | '/sources/edge-gateways/$id/messages/'
    | '/sources/fleets/$id/alerts/'
    | '/sources/fleets/$id/cloud-storage/'
    | '/sources/fleets/$id/configurations/'
    | '/sources/fleets/$id/dashboards/'
    | '/sources/fleets/$id/edge-gateways/'
    | '/sources/fleets/$id/general/'
    | '/sources/fleets/$id/reports/'
    | '/sources/fleets/$id/resources/'
    | '/sources/projects/$id/dashboards/'
    | '/sources/projects/$id/edge-gateways/'
    | '/sources/projects/$id/general/'
    | '/sources/projects/$id/reports/'
    | '/sources/projects/$id/resources/'
    | '/storage-hub/capture-storage/blob/$id/'
    | '/storage-hub/capture-storage/database/$id/'
    | '/sources/edge-gateways/$id/messages/$app/$tab'
    | '/sources/fleets/$id/alerts/no-data-alert/notification'
    | '/sources/fleets/$id/alerts/no-data-alert/trigger'
    | '/sources/edge-gateways/$id/messages/$app/'
    | '/sources/fleets/$id/alerts/$alertId/'
    | '/sources/fleets/$id/alerts/no-data-alert/'
    | '/sources/fleets/$id/cloud-storage/databases/'
    | '/sources/fleets/$id/cloud-storage/parent-db-sync/'
    | '/sources/projects/$id/reports/$reportConfigId/'
    | '/sources/edge-gateways/$id/messages/$app/$tab/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  AdminLayoutRoute: typeof AdminLayoutRouteWithChildren
  IdentityAndAccessLayoutRoute: typeof IdentityAndAccessLayoutRouteWithChildren
  ResourcesLayoutRoute: typeof ResourcesLayoutRouteWithChildren
  SourcesLayoutRoute: typeof SourcesLayoutRouteWithChildren
  StorageHubLayoutRoute: typeof StorageHubLayoutRouteWithChildren
  UnsLayoutRoute: typeof UnsLayoutRouteWithChildren
  AppIdRoute: typeof AppIdRoute
  CaptainAiChatIdRoute: typeof CaptainAiChatIdRoute
  CaptainAiIndexRoute: typeof CaptainAiIndexRoute
  CaptureIndexRoute: typeof CaptureIndexRoute
  DashboardsIndexRoute: typeof DashboardsIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  DashboardsIdIndexRoute: typeof DashboardsIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/uns': {
      id: '/uns'
      path: '/uns'
      fullPath: '/uns'
      preLoaderRoute: typeof UnsLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage-hub': {
      id: '/storage-hub'
      path: '/storage-hub'
      fullPath: '/storage-hub'
      preLoaderRoute: typeof StorageHubLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sources': {
      id: '/sources'
      path: '/sources'
      fullPath: '/sources'
      preLoaderRoute: typeof SourcesLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/resources': {
      id: '/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof ResourcesLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identity-and-access': {
      id: '/identity-and-access'
      path: '/identity-and-access'
      fullPath: '/identity-and-access'
      preLoaderRoute: typeof IdentityAndAccessLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uns/': {
      id: '/uns/'
      path: '/'
      fullPath: '/uns/'
      preLoaderRoute: typeof UnsIndexRouteImport
      parentRoute: typeof UnsLayoutRoute
    }
    '/storage-hub/': {
      id: '/storage-hub/'
      path: '/'
      fullPath: '/storage-hub/'
      preLoaderRoute: typeof StorageHubIndexRouteImport
      parentRoute: typeof StorageHubLayoutRoute
    }
    '/sources/': {
      id: '/sources/'
      path: '/'
      fullPath: '/sources/'
      preLoaderRoute: typeof SourcesIndexRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/resources/': {
      id: '/resources/'
      path: '/'
      fullPath: '/resources/'
      preLoaderRoute: typeof ResourcesIndexRouteImport
      parentRoute: typeof ResourcesLayoutRoute
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/identity-and-access/': {
      id: '/identity-and-access/'
      path: '/'
      fullPath: '/identity-and-access/'
      preLoaderRoute: typeof IdentityAndAccessIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/dashboards/': {
      id: '/dashboards/'
      path: '/dashboards'
      fullPath: '/dashboards/'
      preLoaderRoute: typeof DashboardsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capture/': {
      id: '/capture/'
      path: '/capture'
      fullPath: '/capture/'
      preLoaderRoute: typeof CaptureIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/captain-ai/': {
      id: '/captain-ai/'
      path: '/captain-ai'
      fullPath: '/captain-ai/'
      preLoaderRoute: typeof CaptainAiIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/captain-ai/$chatId': {
      id: '/captain-ai/$chatId'
      path: '/captain-ai/$chatId'
      fullPath: '/captain-ai/$chatId'
      preLoaderRoute: typeof CaptainAiChatIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/$id': {
      id: '/app/$id'
      path: '/app/$id'
      fullPath: '/app/$id'
      preLoaderRoute: typeof AppIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/storage-hub/capture-storage': {
      id: '/storage-hub/capture-storage'
      path: '/capture-storage'
      fullPath: '/storage-hub/capture-storage'
      preLoaderRoute: typeof StorageHubCaptureStorageLayoutRouteImport
      parentRoute: typeof StorageHubLayoutRoute
    }
    '/resources/$id': {
      id: '/resources/$id'
      path: '/$id'
      fullPath: '/resources/$id'
      preLoaderRoute: typeof ResourcesIdLayoutRouteImport
      parentRoute: typeof ResourcesLayoutRoute
    }
    '/uns/home/': {
      id: '/uns/home/'
      path: '/home'
      fullPath: '/uns/home/'
      preLoaderRoute: typeof UnsHomeIndexLazyRouteImport
      parentRoute: typeof UnsLayoutRoute
    }
    '/sources/home/': {
      id: '/sources/home/'
      path: '/home'
      fullPath: '/sources/home/'
      preLoaderRoute: typeof SourcesHomeIndexLazyRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/identity-and-access/home/': {
      id: '/identity-and-access/home/'
      path: '/home'
      fullPath: '/identity-and-access/home/'
      preLoaderRoute: typeof IdentityAndAccessHomeIndexLazyRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/admin/home/': {
      id: '/admin/home/'
      path: '/home'
      fullPath: '/admin/home/'
      preLoaderRoute: typeof AdminHomeIndexLazyRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/uns/uns-builder/': {
      id: '/uns/uns-builder/'
      path: '/uns-builder'
      fullPath: '/uns/uns-builder/'
      preLoaderRoute: typeof UnsUnsBuilderIndexRouteImport
      parentRoute: typeof UnsLayoutRoute
    }
    '/uns/metadatabundles/': {
      id: '/uns/metadatabundles/'
      path: '/metadatabundles'
      fullPath: '/uns/metadatabundles/'
      preLoaderRoute: typeof UnsMetadatabundlesIndexRouteImport
      parentRoute: typeof UnsLayoutRoute
    }
    '/uns/data-explorer/': {
      id: '/uns/data-explorer/'
      path: '/data-explorer'
      fullPath: '/uns/data-explorer/'
      preLoaderRoute: typeof UnsDataExplorerIndexRouteImport
      parentRoute: typeof UnsLayoutRoute
    }
    '/storage-hub/capture-storage/': {
      id: '/storage-hub/capture-storage/'
      path: '/'
      fullPath: '/storage-hub/capture-storage/'
      preLoaderRoute: typeof StorageHubCaptureStorageIndexRouteImport
      parentRoute: typeof StorageHubCaptureStorageLayoutRoute
    }
    '/sources/projects/': {
      id: '/sources/projects/'
      path: '/projects'
      fullPath: '/sources/projects/'
      preLoaderRoute: typeof SourcesProjectsIndexRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/fleets/': {
      id: '/sources/fleets/'
      path: '/fleets'
      fullPath: '/sources/fleets/'
      preLoaderRoute: typeof SourcesFleetsIndexRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/edge-gateways/': {
      id: '/sources/edge-gateways/'
      path: '/edge-gateways'
      fullPath: '/sources/edge-gateways/'
      preLoaderRoute: typeof SourcesEdgeGatewaysIndexRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/configurations/': {
      id: '/sources/configurations/'
      path: '/configurations'
      fullPath: '/sources/configurations/'
      preLoaderRoute: typeof SourcesConfigurationsIndexRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/resources/$id/': {
      id: '/resources/$id/'
      path: '/'
      fullPath: '/resources/$id/'
      preLoaderRoute: typeof ResourcesIdIndexRouteImport
      parentRoute: typeof ResourcesIdLayoutRoute
    }
    '/identity-and-access/users/': {
      id: '/identity-and-access/users/'
      path: '/users'
      fullPath: '/identity-and-access/users/'
      preLoaderRoute: typeof IdentityAndAccessUsersIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/identity-and-access/roles/': {
      id: '/identity-and-access/roles/'
      path: '/roles'
      fullPath: '/identity-and-access/roles/'
      preLoaderRoute: typeof IdentityAndAccessRolesIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/identity-and-access/groups/': {
      id: '/identity-and-access/groups/'
      path: '/groups'
      fullPath: '/identity-and-access/groups/'
      preLoaderRoute: typeof IdentityAndAccessGroupsIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/identity-and-access/companies/': {
      id: '/identity-and-access/companies/'
      path: '/companies'
      fullPath: '/identity-and-access/companies/'
      preLoaderRoute: typeof IdentityAndAccessCompaniesIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/identity-and-access/api-tokens/': {
      id: '/identity-and-access/api-tokens/'
      path: '/api-tokens'
      fullPath: '/identity-and-access/api-tokens/'
      preLoaderRoute: typeof IdentityAndAccessApiTokensIndexRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/dashboards/$id/': {
      id: '/dashboards/$id/'
      path: '/dashboards/$id'
      fullPath: '/dashboards/$id/'
      preLoaderRoute: typeof DashboardsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/terms-and-privacy/': {
      id: '/admin/terms-and-privacy/'
      path: '/terms-and-privacy'
      fullPath: '/admin/terms-and-privacy/'
      preLoaderRoute: typeof AdminTermsAndPrivacyIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/native-apps/': {
      id: '/admin/native-apps/'
      path: '/native-apps'
      fullPath: '/admin/native-apps/'
      preLoaderRoute: typeof AdminNativeAppsIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/custom-apps/': {
      id: '/admin/custom-apps/'
      path: '/custom-apps'
      fullPath: '/admin/custom-apps/'
      preLoaderRoute: typeof AdminCustomAppsIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/cache/': {
      id: '/admin/cache/'
      path: '/cache'
      fullPath: '/admin/cache/'
      preLoaderRoute: typeof AdminCacheIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/admin/announcements/': {
      id: '/admin/announcements/'
      path: '/announcements'
      fullPath: '/admin/announcements/'
      preLoaderRoute: typeof AdminAnnouncementsIndexRouteImport
      parentRoute: typeof AdminLayoutRoute
    }
    '/resources/$id/general': {
      id: '/resources/$id/general'
      path: '/general'
      fullPath: '/resources/$id/general'
      preLoaderRoute: typeof ResourcesIdGeneralRouteImport
      parentRoute: typeof ResourcesIdLayoutRoute
    }
    '/sources/projects/$id': {
      id: '/sources/projects/$id'
      path: '/projects/$id'
      fullPath: '/sources/projects/$id'
      preLoaderRoute: typeof SourcesProjectsIdLayoutRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/fleets/$id': {
      id: '/sources/fleets/$id'
      path: '/fleets/$id'
      fullPath: '/sources/fleets/$id'
      preLoaderRoute: typeof SourcesFleetsIdLayoutRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/edge-gateways/$id': {
      id: '/sources/edge-gateways/$id'
      path: '/edge-gateways/$id'
      fullPath: '/sources/edge-gateways/$id'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdLayoutRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/sources/configurations/$id': {
      id: '/sources/configurations/$id'
      path: '/configurations/$id'
      fullPath: '/sources/configurations/$id'
      preLoaderRoute: typeof SourcesConfigurationsIdLayoutRouteImport
      parentRoute: typeof SourcesLayoutRoute
    }
    '/resources/$id/versions': {
      id: '/resources/$id/versions'
      path: '/versions'
      fullPath: '/resources/$id/versions'
      preLoaderRoute: typeof ResourcesIdVersionsLayoutRouteImport
      parentRoute: typeof ResourcesIdLayoutRoute
    }
    '/resources/$id/linked-to': {
      id: '/resources/$id/linked-to'
      path: '/linked-to'
      fullPath: '/resources/$id/linked-to'
      preLoaderRoute: typeof ResourcesIdLinkedToLayoutRouteImport
      parentRoute: typeof ResourcesIdLayoutRoute
    }
    '/identity-and-access/api-tokens/new': {
      id: '/identity-and-access/api-tokens/new'
      path: '/api-tokens/new'
      fullPath: '/identity-and-access/api-tokens/new'
      preLoaderRoute: typeof IdentityAndAccessApiTokensNewLayoutRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/identity-and-access/api-tokens/$id': {
      id: '/identity-and-access/api-tokens/$id'
      path: '/api-tokens/$id'
      fullPath: '/identity-and-access/api-tokens/$id'
      preLoaderRoute: typeof IdentityAndAccessApiTokensIdLayoutRouteImport
      parentRoute: typeof IdentityAndAccessLayoutRoute
    }
    '/storage-hub/capture-storage/database/': {
      id: '/storage-hub/capture-storage/database/'
      path: '/database'
      fullPath: '/storage-hub/capture-storage/database/'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIndexRouteImport
      parentRoute: typeof StorageHubCaptureStorageLayoutRoute
    }
    '/storage-hub/capture-storage/blob/': {
      id: '/storage-hub/capture-storage/blob/'
      path: '/blob'
      fullPath: '/storage-hub/capture-storage/blob/'
      preLoaderRoute: typeof StorageHubCaptureStorageBlobIndexRouteImport
      parentRoute: typeof StorageHubCaptureStorageLayoutRoute
    }
    '/sources/projects/$id/': {
      id: '/sources/projects/$id/'
      path: '/'
      fullPath: '/sources/projects/$id/'
      preLoaderRoute: typeof SourcesProjectsIdIndexRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/fleets/$id/': {
      id: '/sources/fleets/$id/'
      path: '/'
      fullPath: '/sources/fleets/$id/'
      preLoaderRoute: typeof SourcesFleetsIdIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/edge-gateways/$id/': {
      id: '/sources/edge-gateways/$id/'
      path: '/'
      fullPath: '/sources/edge-gateways/$id/'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdIndexRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/resources/$id/versions/': {
      id: '/resources/$id/versions/'
      path: '/'
      fullPath: '/resources/$id/versions/'
      preLoaderRoute: typeof ResourcesIdVersionsIndexRouteImport
      parentRoute: typeof ResourcesIdVersionsLayoutRoute
    }
    '/resources/$id/linked-to/': {
      id: '/resources/$id/linked-to/'
      path: '/'
      fullPath: '/resources/$id/linked-to/'
      preLoaderRoute: typeof ResourcesIdLinkedToIndexRouteImport
      parentRoute: typeof ResourcesIdLinkedToLayoutRoute
    }
    '/sources/edge-gateways/$id/variables': {
      id: '/sources/edge-gateways/$id/variables'
      path: '/variables'
      fullPath: '/sources/edge-gateways/$id/variables'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdVariablesRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/sources/edge-gateways/$id/settings': {
      id: '/sources/edge-gateways/$id/settings'
      path: '/settings'
      fullPath: '/sources/edge-gateways/$id/settings'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdSettingsRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/sources/edge-gateways/$id/resources': {
      id: '/sources/edge-gateways/$id/resources'
      path: '/resources'
      fullPath: '/sources/edge-gateways/$id/resources'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdResourcesRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/sources/edge-gateways/$id/overview': {
      id: '/sources/edge-gateways/$id/overview'
      path: '/overview'
      fullPath: '/sources/edge-gateways/$id/overview'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdOverviewRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/sources/edge-gateways/$id/cloud-storage': {
      id: '/sources/edge-gateways/$id/cloud-storage'
      path: '/cloud-storage'
      fullPath: '/sources/edge-gateways/$id/cloud-storage'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdCloudStorageRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/sources/edge-gateways/$id/alerts': {
      id: '/sources/edge-gateways/$id/alerts'
      path: '/alerts'
      fullPath: '/sources/edge-gateways/$id/alerts'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdAlertsRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/resources/$id/linked-to/projects': {
      id: '/resources/$id/linked-to/projects'
      path: '/projects'
      fullPath: '/resources/$id/linked-to/projects'
      preLoaderRoute: typeof ResourcesIdLinkedToProjectsRouteImport
      parentRoute: typeof ResourcesIdLinkedToLayoutRoute
    }
    '/resources/$id/linked-to/fleets': {
      id: '/resources/$id/linked-to/fleets'
      path: '/fleets'
      fullPath: '/resources/$id/linked-to/fleets'
      preLoaderRoute: typeof ResourcesIdLinkedToFleetsRouteImport
      parentRoute: typeof ResourcesIdLinkedToLayoutRoute
    }
    '/resources/$id/linked-to/edge-gateways': {
      id: '/resources/$id/linked-to/edge-gateways'
      path: '/edge-gateways'
      fullPath: '/resources/$id/linked-to/edge-gateways'
      preLoaderRoute: typeof ResourcesIdLinkedToEdgeGatewaysRouteImport
      parentRoute: typeof ResourcesIdLinkedToLayoutRoute
    }
    '/identity-and-access/api-tokens/new/permissions': {
      id: '/identity-and-access/api-tokens/new/permissions'
      path: '/permissions'
      fullPath: '/identity-and-access/api-tokens/new/permissions'
      preLoaderRoute: typeof IdentityAndAccessApiTokensNewPermissionsRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensNewLayoutRoute
    }
    '/identity-and-access/api-tokens/new/general': {
      id: '/identity-and-access/api-tokens/new/general'
      path: '/general'
      fullPath: '/identity-and-access/api-tokens/new/general'
      preLoaderRoute: typeof IdentityAndAccessApiTokensNewGeneralRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensNewLayoutRoute
    }
    '/identity-and-access/api-tokens/new/databases': {
      id: '/identity-and-access/api-tokens/new/databases'
      path: '/databases'
      fullPath: '/identity-and-access/api-tokens/new/databases'
      preLoaderRoute: typeof IdentityAndAccessApiTokensNewDatabasesRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensNewLayoutRoute
    }
    '/identity-and-access/api-tokens/$id/permissions': {
      id: '/identity-and-access/api-tokens/$id/permissions'
      path: '/permissions'
      fullPath: '/identity-and-access/api-tokens/$id/permissions'
      preLoaderRoute: typeof IdentityAndAccessApiTokensIdPermissionsRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensIdLayoutRoute
    }
    '/identity-and-access/api-tokens/$id/general': {
      id: '/identity-and-access/api-tokens/$id/general'
      path: '/general'
      fullPath: '/identity-and-access/api-tokens/$id/general'
      preLoaderRoute: typeof IdentityAndAccessApiTokensIdGeneralRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensIdLayoutRoute
    }
    '/identity-and-access/api-tokens/$id/databases': {
      id: '/identity-and-access/api-tokens/$id/databases'
      path: '/databases'
      fullPath: '/identity-and-access/api-tokens/$id/databases'
      preLoaderRoute: typeof IdentityAndAccessApiTokensIdDatabasesRouteImport
      parentRoute: typeof IdentityAndAccessApiTokensIdLayoutRoute
    }
    '/storage-hub/capture-storage/database/$id': {
      id: '/storage-hub/capture-storage/database/$id'
      path: '/database/$id'
      fullPath: '/storage-hub/capture-storage/database/$id'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRouteImport
      parentRoute: typeof StorageHubCaptureStorageLayoutRoute
    }
    '/storage-hub/capture-storage/blob/$id': {
      id: '/storage-hub/capture-storage/blob/$id'
      path: '/blob/$id'
      fullPath: '/storage-hub/capture-storage/blob/$id'
      preLoaderRoute: typeof StorageHubCaptureStorageBlobIdLayoutRouteImport
      parentRoute: typeof StorageHubCaptureStorageLayoutRoute
    }
    '/sources/projects/$id/reports': {
      id: '/sources/projects/$id/reports'
      path: '/reports'
      fullPath: '/sources/projects/$id/reports'
      preLoaderRoute: typeof SourcesProjectsIdReportsLayoutRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/fleets/$id/cloud-storage': {
      id: '/sources/fleets/$id/cloud-storage'
      path: '/cloud-storage'
      fullPath: '/sources/fleets/$id/cloud-storage'
      preLoaderRoute: typeof SourcesFleetsIdCloudStorageLayoutRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/alerts': {
      id: '/sources/fleets/$id/alerts'
      path: '/alerts'
      fullPath: '/sources/fleets/$id/alerts'
      preLoaderRoute: typeof SourcesFleetsIdAlertsLayoutRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/edge-gateways/$id/messages': {
      id: '/sources/edge-gateways/$id/messages'
      path: '/messages'
      fullPath: '/sources/edge-gateways/$id/messages'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdMessagesLayoutRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdLayoutRoute
    }
    '/resources/$id/versions/new': {
      id: '/resources/$id/versions/new'
      path: '/new'
      fullPath: '/resources/$id/versions/new'
      preLoaderRoute: typeof ResourcesIdVersionsNewLayoutRouteImport
      parentRoute: typeof ResourcesIdVersionsLayoutRoute
    }
    '/resources/$id/versions/$versionId': {
      id: '/resources/$id/versions/$versionId'
      path: '/$versionId'
      fullPath: '/resources/$id/versions/$versionId'
      preLoaderRoute: typeof ResourcesIdVersionsVersionIdLayoutRouteImport
      parentRoute: typeof ResourcesIdVersionsLayoutRoute
    }
    '/storage-hub/capture-storage/database/$id/': {
      id: '/storage-hub/capture-storage/database/$id/'
      path: '/'
      fullPath: '/storage-hub/capture-storage/database/$id/'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIdIndexRouteImport
      parentRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRoute
    }
    '/storage-hub/capture-storage/blob/$id/': {
      id: '/storage-hub/capture-storage/blob/$id/'
      path: '/'
      fullPath: '/storage-hub/capture-storage/blob/$id/'
      preLoaderRoute: typeof StorageHubCaptureStorageBlobIdIndexRouteImport
      parentRoute: typeof StorageHubCaptureStorageBlobIdLayoutRoute
    }
    '/sources/projects/$id/resources/': {
      id: '/sources/projects/$id/resources/'
      path: '/resources'
      fullPath: '/sources/projects/$id/resources/'
      preLoaderRoute: typeof SourcesProjectsIdResourcesIndexRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/projects/$id/reports/': {
      id: '/sources/projects/$id/reports/'
      path: '/'
      fullPath: '/sources/projects/$id/reports/'
      preLoaderRoute: typeof SourcesProjectsIdReportsIndexRouteImport
      parentRoute: typeof SourcesProjectsIdReportsLayoutRoute
    }
    '/sources/projects/$id/general/': {
      id: '/sources/projects/$id/general/'
      path: '/general'
      fullPath: '/sources/projects/$id/general/'
      preLoaderRoute: typeof SourcesProjectsIdGeneralIndexRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/projects/$id/edge-gateways/': {
      id: '/sources/projects/$id/edge-gateways/'
      path: '/edge-gateways'
      fullPath: '/sources/projects/$id/edge-gateways/'
      preLoaderRoute: typeof SourcesProjectsIdEdgeGatewaysIndexRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/projects/$id/dashboards/': {
      id: '/sources/projects/$id/dashboards/'
      path: '/dashboards'
      fullPath: '/sources/projects/$id/dashboards/'
      preLoaderRoute: typeof SourcesProjectsIdDashboardsIndexRouteImport
      parentRoute: typeof SourcesProjectsIdLayoutRoute
    }
    '/sources/fleets/$id/resources/': {
      id: '/sources/fleets/$id/resources/'
      path: '/resources'
      fullPath: '/sources/fleets/$id/resources/'
      preLoaderRoute: typeof SourcesFleetsIdResourcesIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/reports/': {
      id: '/sources/fleets/$id/reports/'
      path: '/reports'
      fullPath: '/sources/fleets/$id/reports/'
      preLoaderRoute: typeof SourcesFleetsIdReportsIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/general/': {
      id: '/sources/fleets/$id/general/'
      path: '/general'
      fullPath: '/sources/fleets/$id/general/'
      preLoaderRoute: typeof SourcesFleetsIdGeneralIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/edge-gateways/': {
      id: '/sources/fleets/$id/edge-gateways/'
      path: '/edge-gateways'
      fullPath: '/sources/fleets/$id/edge-gateways/'
      preLoaderRoute: typeof SourcesFleetsIdEdgeGatewaysIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/dashboards/': {
      id: '/sources/fleets/$id/dashboards/'
      path: '/dashboards'
      fullPath: '/sources/fleets/$id/dashboards/'
      preLoaderRoute: typeof SourcesFleetsIdDashboardsIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/configurations/': {
      id: '/sources/fleets/$id/configurations/'
      path: '/configurations'
      fullPath: '/sources/fleets/$id/configurations/'
      preLoaderRoute: typeof SourcesFleetsIdConfigurationsIndexRouteImport
      parentRoute: typeof SourcesFleetsIdLayoutRoute
    }
    '/sources/fleets/$id/cloud-storage/': {
      id: '/sources/fleets/$id/cloud-storage/'
      path: '/'
      fullPath: '/sources/fleets/$id/cloud-storage/'
      preLoaderRoute: typeof SourcesFleetsIdCloudStorageIndexRouteImport
      parentRoute: typeof SourcesFleetsIdCloudStorageLayoutRoute
    }
    '/sources/fleets/$id/alerts/': {
      id: '/sources/fleets/$id/alerts/'
      path: '/'
      fullPath: '/sources/fleets/$id/alerts/'
      preLoaderRoute: typeof SourcesFleetsIdAlertsIndexRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsLayoutRoute
    }
    '/sources/edge-gateways/$id/messages/': {
      id: '/sources/edge-gateways/$id/messages/'
      path: '/'
      fullPath: '/sources/edge-gateways/$id/messages/'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdMessagesIndexRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdMessagesLayoutRoute
    }
    '/resources/$id/versions/$versionId/': {
      id: '/resources/$id/versions/$versionId/'
      path: '/'
      fullPath: '/resources/$id/versions/$versionId/'
      preLoaderRoute: typeof ResourcesIdVersionsVersionIdIndexRouteImport
      parentRoute: typeof ResourcesIdVersionsVersionIdLayoutRoute
    }
    '/storage-hub/capture-storage/database/$id/settings': {
      id: '/storage-hub/capture-storage/database/$id/settings'
      path: '/settings'
      fullPath: '/storage-hub/capture-storage/database/$id/settings'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIdSettingsRouteImport
      parentRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRoute
    }
    '/storage-hub/capture-storage/database/$id/permissions': {
      id: '/storage-hub/capture-storage/database/$id/permissions'
      path: '/permissions'
      fullPath: '/storage-hub/capture-storage/database/$id/permissions'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIdPermissionsRouteImport
      parentRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRoute
    }
    '/storage-hub/capture-storage/database/$id/measurements': {
      id: '/storage-hub/capture-storage/database/$id/measurements'
      path: '/measurements'
      fullPath: '/storage-hub/capture-storage/database/$id/measurements'
      preLoaderRoute: typeof StorageHubCaptureStorageDatabaseIdMeasurementsRouteImport
      parentRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRoute
    }
    '/storage-hub/capture-storage/blob/$id/settings': {
      id: '/storage-hub/capture-storage/blob/$id/settings'
      path: '/settings'
      fullPath: '/storage-hub/capture-storage/blob/$id/settings'
      preLoaderRoute: typeof StorageHubCaptureStorageBlobIdSettingsRouteImport
      parentRoute: typeof StorageHubCaptureStorageBlobIdLayoutRoute
    }
    '/resources/$id/versions/new/variables': {
      id: '/resources/$id/versions/new/variables'
      path: '/variables'
      fullPath: '/resources/$id/versions/new/variables'
      preLoaderRoute: typeof ResourcesIdVersionsNewVariablesRouteImport
      parentRoute: typeof ResourcesIdVersionsNewLayoutRoute
    }
    '/resources/$id/versions/new/general': {
      id: '/resources/$id/versions/new/general'
      path: '/general'
      fullPath: '/resources/$id/versions/new/general'
      preLoaderRoute: typeof ResourcesIdVersionsNewGeneralRouteImport
      parentRoute: typeof ResourcesIdVersionsNewLayoutRoute
    }
    '/resources/$id/versions/$versionId/variables': {
      id: '/resources/$id/versions/$versionId/variables'
      path: '/variables'
      fullPath: '/resources/$id/versions/$versionId/variables'
      preLoaderRoute: typeof ResourcesIdVersionsVersionIdVariablesRouteImport
      parentRoute: typeof ResourcesIdVersionsVersionIdLayoutRoute
    }
    '/resources/$id/versions/$versionId/general': {
      id: '/resources/$id/versions/$versionId/general'
      path: '/general'
      fullPath: '/resources/$id/versions/$versionId/general'
      preLoaderRoute: typeof ResourcesIdVersionsVersionIdGeneralRouteImport
      parentRoute: typeof ResourcesIdVersionsVersionIdLayoutRoute
    }
    '/sources/fleets/$id/alerts/no-data-alert': {
      id: '/sources/fleets/$id/alerts/no-data-alert'
      path: '/no-data-alert'
      fullPath: '/sources/fleets/$id/alerts/no-data-alert'
      preLoaderRoute: typeof SourcesFleetsIdAlertsNoDataAlertLayoutRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsLayoutRoute
    }
    '/sources/projects/$id/reports/$reportConfigId/': {
      id: '/sources/projects/$id/reports/$reportConfigId/'
      path: '/$reportConfigId'
      fullPath: '/sources/projects/$id/reports/$reportConfigId/'
      preLoaderRoute: typeof SourcesProjectsIdReportsReportConfigIdIndexRouteImport
      parentRoute: typeof SourcesProjectsIdReportsLayoutRoute
    }
    '/sources/fleets/$id/cloud-storage/parent-db-sync/': {
      id: '/sources/fleets/$id/cloud-storage/parent-db-sync/'
      path: '/parent-db-sync'
      fullPath: '/sources/fleets/$id/cloud-storage/parent-db-sync/'
      preLoaderRoute: typeof SourcesFleetsIdCloudStorageParentDbSyncIndexRouteImport
      parentRoute: typeof SourcesFleetsIdCloudStorageLayoutRoute
    }
    '/sources/fleets/$id/cloud-storage/databases/': {
      id: '/sources/fleets/$id/cloud-storage/databases/'
      path: '/databases'
      fullPath: '/sources/fleets/$id/cloud-storage/databases/'
      preLoaderRoute: typeof SourcesFleetsIdCloudStorageDatabasesIndexRouteImport
      parentRoute: typeof SourcesFleetsIdCloudStorageLayoutRoute
    }
    '/sources/fleets/$id/alerts/no-data-alert/': {
      id: '/sources/fleets/$id/alerts/no-data-alert/'
      path: '/'
      fullPath: '/sources/fleets/$id/alerts/no-data-alert/'
      preLoaderRoute: typeof SourcesFleetsIdAlertsNoDataAlertIndexRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsNoDataAlertLayoutRoute
    }
    '/sources/fleets/$id/alerts/$alertId/': {
      id: '/sources/fleets/$id/alerts/$alertId/'
      path: '/$alertId'
      fullPath: '/sources/fleets/$id/alerts/$alertId/'
      preLoaderRoute: typeof SourcesFleetsIdAlertsAlertIdIndexRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsLayoutRoute
    }
    '/sources/edge-gateways/$id/messages/$app/': {
      id: '/sources/edge-gateways/$id/messages/$app/'
      path: '/$app'
      fullPath: '/sources/edge-gateways/$id/messages/$app/'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdMessagesAppIndexRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdMessagesLayoutRoute
    }
    '/sources/fleets/$id/alerts/no-data-alert/trigger': {
      id: '/sources/fleets/$id/alerts/no-data-alert/trigger'
      path: '/trigger'
      fullPath: '/sources/fleets/$id/alerts/no-data-alert/trigger'
      preLoaderRoute: typeof SourcesFleetsIdAlertsNoDataAlertTriggerRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsNoDataAlertLayoutRoute
    }
    '/sources/fleets/$id/alerts/no-data-alert/notification': {
      id: '/sources/fleets/$id/alerts/no-data-alert/notification'
      path: '/notification'
      fullPath: '/sources/fleets/$id/alerts/no-data-alert/notification'
      preLoaderRoute: typeof SourcesFleetsIdAlertsNoDataAlertNotificationRouteImport
      parentRoute: typeof SourcesFleetsIdAlertsNoDataAlertLayoutRoute
    }
    '/sources/edge-gateways/$id/messages/$app/$tab': {
      id: '/sources/edge-gateways/$id/messages/$app/$tab'
      path: '/$app/$tab'
      fullPath: '/sources/edge-gateways/$id/messages/$app/$tab'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdMessagesLayoutRoute
    }
    '/sources/edge-gateways/$id/messages/$app/$tab/': {
      id: '/sources/edge-gateways/$id/messages/$app/$tab/'
      path: '/'
      fullPath: '/sources/edge-gateways/$id/messages/$app/$tab/'
      preLoaderRoute: typeof SourcesEdgeGatewaysIdMessagesAppTabIndexRouteImport
      parentRoute: typeof SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute
    }
  }
}

interface AdminLayoutRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminAnnouncementsIndexRoute: typeof AdminAnnouncementsIndexRoute
  AdminCacheIndexRoute: typeof AdminCacheIndexRoute
  AdminCustomAppsIndexRoute: typeof AdminCustomAppsIndexRoute
  AdminNativeAppsIndexRoute: typeof AdminNativeAppsIndexRoute
  AdminTermsAndPrivacyIndexRoute: typeof AdminTermsAndPrivacyIndexRoute
  AdminHomeIndexLazyRoute: typeof AdminHomeIndexLazyRoute
}

const AdminLayoutRouteChildren: AdminLayoutRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminAnnouncementsIndexRoute: AdminAnnouncementsIndexRoute,
  AdminCacheIndexRoute: AdminCacheIndexRoute,
  AdminCustomAppsIndexRoute: AdminCustomAppsIndexRoute,
  AdminNativeAppsIndexRoute: AdminNativeAppsIndexRoute,
  AdminTermsAndPrivacyIndexRoute: AdminTermsAndPrivacyIndexRoute,
  AdminHomeIndexLazyRoute: AdminHomeIndexLazyRoute,
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(
  AdminLayoutRouteChildren,
)

interface IdentityAndAccessApiTokensIdLayoutRouteChildren {
  IdentityAndAccessApiTokensIdDatabasesRoute: typeof IdentityAndAccessApiTokensIdDatabasesRoute
  IdentityAndAccessApiTokensIdGeneralRoute: typeof IdentityAndAccessApiTokensIdGeneralRoute
  IdentityAndAccessApiTokensIdPermissionsRoute: typeof IdentityAndAccessApiTokensIdPermissionsRoute
}

const IdentityAndAccessApiTokensIdLayoutRouteChildren: IdentityAndAccessApiTokensIdLayoutRouteChildren =
  {
    IdentityAndAccessApiTokensIdDatabasesRoute:
      IdentityAndAccessApiTokensIdDatabasesRoute,
    IdentityAndAccessApiTokensIdGeneralRoute:
      IdentityAndAccessApiTokensIdGeneralRoute,
    IdentityAndAccessApiTokensIdPermissionsRoute:
      IdentityAndAccessApiTokensIdPermissionsRoute,
  }

const IdentityAndAccessApiTokensIdLayoutRouteWithChildren =
  IdentityAndAccessApiTokensIdLayoutRoute._addFileChildren(
    IdentityAndAccessApiTokensIdLayoutRouteChildren,
  )

interface IdentityAndAccessApiTokensNewLayoutRouteChildren {
  IdentityAndAccessApiTokensNewDatabasesRoute: typeof IdentityAndAccessApiTokensNewDatabasesRoute
  IdentityAndAccessApiTokensNewGeneralRoute: typeof IdentityAndAccessApiTokensNewGeneralRoute
  IdentityAndAccessApiTokensNewPermissionsRoute: typeof IdentityAndAccessApiTokensNewPermissionsRoute
}

const IdentityAndAccessApiTokensNewLayoutRouteChildren: IdentityAndAccessApiTokensNewLayoutRouteChildren =
  {
    IdentityAndAccessApiTokensNewDatabasesRoute:
      IdentityAndAccessApiTokensNewDatabasesRoute,
    IdentityAndAccessApiTokensNewGeneralRoute:
      IdentityAndAccessApiTokensNewGeneralRoute,
    IdentityAndAccessApiTokensNewPermissionsRoute:
      IdentityAndAccessApiTokensNewPermissionsRoute,
  }

const IdentityAndAccessApiTokensNewLayoutRouteWithChildren =
  IdentityAndAccessApiTokensNewLayoutRoute._addFileChildren(
    IdentityAndAccessApiTokensNewLayoutRouteChildren,
  )

interface IdentityAndAccessLayoutRouteChildren {
  IdentityAndAccessIndexRoute: typeof IdentityAndAccessIndexRoute
  IdentityAndAccessApiTokensIdLayoutRoute: typeof IdentityAndAccessApiTokensIdLayoutRouteWithChildren
  IdentityAndAccessApiTokensNewLayoutRoute: typeof IdentityAndAccessApiTokensNewLayoutRouteWithChildren
  IdentityAndAccessApiTokensIndexRoute: typeof IdentityAndAccessApiTokensIndexRoute
  IdentityAndAccessCompaniesIndexRoute: typeof IdentityAndAccessCompaniesIndexRoute
  IdentityAndAccessGroupsIndexRoute: typeof IdentityAndAccessGroupsIndexRoute
  IdentityAndAccessRolesIndexRoute: typeof IdentityAndAccessRolesIndexRoute
  IdentityAndAccessUsersIndexRoute: typeof IdentityAndAccessUsersIndexRoute
  IdentityAndAccessHomeIndexLazyRoute: typeof IdentityAndAccessHomeIndexLazyRoute
}

const IdentityAndAccessLayoutRouteChildren: IdentityAndAccessLayoutRouteChildren =
  {
    IdentityAndAccessIndexRoute: IdentityAndAccessIndexRoute,
    IdentityAndAccessApiTokensIdLayoutRoute:
      IdentityAndAccessApiTokensIdLayoutRouteWithChildren,
    IdentityAndAccessApiTokensNewLayoutRoute:
      IdentityAndAccessApiTokensNewLayoutRouteWithChildren,
    IdentityAndAccessApiTokensIndexRoute: IdentityAndAccessApiTokensIndexRoute,
    IdentityAndAccessCompaniesIndexRoute: IdentityAndAccessCompaniesIndexRoute,
    IdentityAndAccessGroupsIndexRoute: IdentityAndAccessGroupsIndexRoute,
    IdentityAndAccessRolesIndexRoute: IdentityAndAccessRolesIndexRoute,
    IdentityAndAccessUsersIndexRoute: IdentityAndAccessUsersIndexRoute,
    IdentityAndAccessHomeIndexLazyRoute: IdentityAndAccessHomeIndexLazyRoute,
  }

const IdentityAndAccessLayoutRouteWithChildren =
  IdentityAndAccessLayoutRoute._addFileChildren(
    IdentityAndAccessLayoutRouteChildren,
  )

interface ResourcesIdLinkedToLayoutRouteChildren {
  ResourcesIdLinkedToEdgeGatewaysRoute: typeof ResourcesIdLinkedToEdgeGatewaysRoute
  ResourcesIdLinkedToFleetsRoute: typeof ResourcesIdLinkedToFleetsRoute
  ResourcesIdLinkedToProjectsRoute: typeof ResourcesIdLinkedToProjectsRoute
  ResourcesIdLinkedToIndexRoute: typeof ResourcesIdLinkedToIndexRoute
}

const ResourcesIdLinkedToLayoutRouteChildren: ResourcesIdLinkedToLayoutRouteChildren =
  {
    ResourcesIdLinkedToEdgeGatewaysRoute: ResourcesIdLinkedToEdgeGatewaysRoute,
    ResourcesIdLinkedToFleetsRoute: ResourcesIdLinkedToFleetsRoute,
    ResourcesIdLinkedToProjectsRoute: ResourcesIdLinkedToProjectsRoute,
    ResourcesIdLinkedToIndexRoute: ResourcesIdLinkedToIndexRoute,
  }

const ResourcesIdLinkedToLayoutRouteWithChildren =
  ResourcesIdLinkedToLayoutRoute._addFileChildren(
    ResourcesIdLinkedToLayoutRouteChildren,
  )

interface ResourcesIdVersionsVersionIdLayoutRouteChildren {
  ResourcesIdVersionsVersionIdGeneralRoute: typeof ResourcesIdVersionsVersionIdGeneralRoute
  ResourcesIdVersionsVersionIdVariablesRoute: typeof ResourcesIdVersionsVersionIdVariablesRoute
  ResourcesIdVersionsVersionIdIndexRoute: typeof ResourcesIdVersionsVersionIdIndexRoute
}

const ResourcesIdVersionsVersionIdLayoutRouteChildren: ResourcesIdVersionsVersionIdLayoutRouteChildren =
  {
    ResourcesIdVersionsVersionIdGeneralRoute:
      ResourcesIdVersionsVersionIdGeneralRoute,
    ResourcesIdVersionsVersionIdVariablesRoute:
      ResourcesIdVersionsVersionIdVariablesRoute,
    ResourcesIdVersionsVersionIdIndexRoute:
      ResourcesIdVersionsVersionIdIndexRoute,
  }

const ResourcesIdVersionsVersionIdLayoutRouteWithChildren =
  ResourcesIdVersionsVersionIdLayoutRoute._addFileChildren(
    ResourcesIdVersionsVersionIdLayoutRouteChildren,
  )

interface ResourcesIdVersionsNewLayoutRouteChildren {
  ResourcesIdVersionsNewGeneralRoute: typeof ResourcesIdVersionsNewGeneralRoute
  ResourcesIdVersionsNewVariablesRoute: typeof ResourcesIdVersionsNewVariablesRoute
}

const ResourcesIdVersionsNewLayoutRouteChildren: ResourcesIdVersionsNewLayoutRouteChildren =
  {
    ResourcesIdVersionsNewGeneralRoute: ResourcesIdVersionsNewGeneralRoute,
    ResourcesIdVersionsNewVariablesRoute: ResourcesIdVersionsNewVariablesRoute,
  }

const ResourcesIdVersionsNewLayoutRouteWithChildren =
  ResourcesIdVersionsNewLayoutRoute._addFileChildren(
    ResourcesIdVersionsNewLayoutRouteChildren,
  )

interface ResourcesIdVersionsLayoutRouteChildren {
  ResourcesIdVersionsVersionIdLayoutRoute: typeof ResourcesIdVersionsVersionIdLayoutRouteWithChildren
  ResourcesIdVersionsNewLayoutRoute: typeof ResourcesIdVersionsNewLayoutRouteWithChildren
  ResourcesIdVersionsIndexRoute: typeof ResourcesIdVersionsIndexRoute
}

const ResourcesIdVersionsLayoutRouteChildren: ResourcesIdVersionsLayoutRouteChildren =
  {
    ResourcesIdVersionsVersionIdLayoutRoute:
      ResourcesIdVersionsVersionIdLayoutRouteWithChildren,
    ResourcesIdVersionsNewLayoutRoute:
      ResourcesIdVersionsNewLayoutRouteWithChildren,
    ResourcesIdVersionsIndexRoute: ResourcesIdVersionsIndexRoute,
  }

const ResourcesIdVersionsLayoutRouteWithChildren =
  ResourcesIdVersionsLayoutRoute._addFileChildren(
    ResourcesIdVersionsLayoutRouteChildren,
  )

interface ResourcesIdLayoutRouteChildren {
  ResourcesIdLinkedToLayoutRoute: typeof ResourcesIdLinkedToLayoutRouteWithChildren
  ResourcesIdVersionsLayoutRoute: typeof ResourcesIdVersionsLayoutRouteWithChildren
  ResourcesIdGeneralRoute: typeof ResourcesIdGeneralRoute
  ResourcesIdIndexRoute: typeof ResourcesIdIndexRoute
}

const ResourcesIdLayoutRouteChildren: ResourcesIdLayoutRouteChildren = {
  ResourcesIdLinkedToLayoutRoute: ResourcesIdLinkedToLayoutRouteWithChildren,
  ResourcesIdVersionsLayoutRoute: ResourcesIdVersionsLayoutRouteWithChildren,
  ResourcesIdGeneralRoute: ResourcesIdGeneralRoute,
  ResourcesIdIndexRoute: ResourcesIdIndexRoute,
}

const ResourcesIdLayoutRouteWithChildren =
  ResourcesIdLayoutRoute._addFileChildren(ResourcesIdLayoutRouteChildren)

interface ResourcesLayoutRouteChildren {
  ResourcesIdLayoutRoute: typeof ResourcesIdLayoutRouteWithChildren
  ResourcesIndexRoute: typeof ResourcesIndexRoute
}

const ResourcesLayoutRouteChildren: ResourcesLayoutRouteChildren = {
  ResourcesIdLayoutRoute: ResourcesIdLayoutRouteWithChildren,
  ResourcesIndexRoute: ResourcesIndexRoute,
}

const ResourcesLayoutRouteWithChildren = ResourcesLayoutRoute._addFileChildren(
  ResourcesLayoutRouteChildren,
)

interface SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteChildren {
  SourcesEdgeGatewaysIdMessagesAppTabIndexRoute: typeof SourcesEdgeGatewaysIdMessagesAppTabIndexRoute
}

const SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteChildren: SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteChildren =
  {
    SourcesEdgeGatewaysIdMessagesAppTabIndexRoute:
      SourcesEdgeGatewaysIdMessagesAppTabIndexRoute,
  }

const SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteWithChildren =
  SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute._addFileChildren(
    SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteChildren,
  )

interface SourcesEdgeGatewaysIdMessagesLayoutRouteChildren {
  SourcesEdgeGatewaysIdMessagesIndexRoute: typeof SourcesEdgeGatewaysIdMessagesIndexRoute
  SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute: typeof SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteWithChildren
  SourcesEdgeGatewaysIdMessagesAppIndexRoute: typeof SourcesEdgeGatewaysIdMessagesAppIndexRoute
}

const SourcesEdgeGatewaysIdMessagesLayoutRouteChildren: SourcesEdgeGatewaysIdMessagesLayoutRouteChildren =
  {
    SourcesEdgeGatewaysIdMessagesIndexRoute:
      SourcesEdgeGatewaysIdMessagesIndexRoute,
    SourcesEdgeGatewaysIdMessagesAppTabLayoutRoute:
      SourcesEdgeGatewaysIdMessagesAppTabLayoutRouteWithChildren,
    SourcesEdgeGatewaysIdMessagesAppIndexRoute:
      SourcesEdgeGatewaysIdMessagesAppIndexRoute,
  }

const SourcesEdgeGatewaysIdMessagesLayoutRouteWithChildren =
  SourcesEdgeGatewaysIdMessagesLayoutRoute._addFileChildren(
    SourcesEdgeGatewaysIdMessagesLayoutRouteChildren,
  )

interface SourcesEdgeGatewaysIdLayoutRouteChildren {
  SourcesEdgeGatewaysIdMessagesLayoutRoute: typeof SourcesEdgeGatewaysIdMessagesLayoutRouteWithChildren
  SourcesEdgeGatewaysIdAlertsRoute: typeof SourcesEdgeGatewaysIdAlertsRoute
  SourcesEdgeGatewaysIdCloudStorageRoute: typeof SourcesEdgeGatewaysIdCloudStorageRoute
  SourcesEdgeGatewaysIdOverviewRoute: typeof SourcesEdgeGatewaysIdOverviewRoute
  SourcesEdgeGatewaysIdResourcesRoute: typeof SourcesEdgeGatewaysIdResourcesRoute
  SourcesEdgeGatewaysIdSettingsRoute: typeof SourcesEdgeGatewaysIdSettingsRoute
  SourcesEdgeGatewaysIdVariablesRoute: typeof SourcesEdgeGatewaysIdVariablesRoute
  SourcesEdgeGatewaysIdIndexRoute: typeof SourcesEdgeGatewaysIdIndexRoute
}

const SourcesEdgeGatewaysIdLayoutRouteChildren: SourcesEdgeGatewaysIdLayoutRouteChildren =
  {
    SourcesEdgeGatewaysIdMessagesLayoutRoute:
      SourcesEdgeGatewaysIdMessagesLayoutRouteWithChildren,
    SourcesEdgeGatewaysIdAlertsRoute: SourcesEdgeGatewaysIdAlertsRoute,
    SourcesEdgeGatewaysIdCloudStorageRoute:
      SourcesEdgeGatewaysIdCloudStorageRoute,
    SourcesEdgeGatewaysIdOverviewRoute: SourcesEdgeGatewaysIdOverviewRoute,
    SourcesEdgeGatewaysIdResourcesRoute: SourcesEdgeGatewaysIdResourcesRoute,
    SourcesEdgeGatewaysIdSettingsRoute: SourcesEdgeGatewaysIdSettingsRoute,
    SourcesEdgeGatewaysIdVariablesRoute: SourcesEdgeGatewaysIdVariablesRoute,
    SourcesEdgeGatewaysIdIndexRoute: SourcesEdgeGatewaysIdIndexRoute,
  }

const SourcesEdgeGatewaysIdLayoutRouteWithChildren =
  SourcesEdgeGatewaysIdLayoutRoute._addFileChildren(
    SourcesEdgeGatewaysIdLayoutRouteChildren,
  )

interface SourcesFleetsIdAlertsNoDataAlertLayoutRouteChildren {
  SourcesFleetsIdAlertsNoDataAlertNotificationRoute: typeof SourcesFleetsIdAlertsNoDataAlertNotificationRoute
  SourcesFleetsIdAlertsNoDataAlertTriggerRoute: typeof SourcesFleetsIdAlertsNoDataAlertTriggerRoute
  SourcesFleetsIdAlertsNoDataAlertIndexRoute: typeof SourcesFleetsIdAlertsNoDataAlertIndexRoute
}

const SourcesFleetsIdAlertsNoDataAlertLayoutRouteChildren: SourcesFleetsIdAlertsNoDataAlertLayoutRouteChildren =
  {
    SourcesFleetsIdAlertsNoDataAlertNotificationRoute:
      SourcesFleetsIdAlertsNoDataAlertNotificationRoute,
    SourcesFleetsIdAlertsNoDataAlertTriggerRoute:
      SourcesFleetsIdAlertsNoDataAlertTriggerRoute,
    SourcesFleetsIdAlertsNoDataAlertIndexRoute:
      SourcesFleetsIdAlertsNoDataAlertIndexRoute,
  }

const SourcesFleetsIdAlertsNoDataAlertLayoutRouteWithChildren =
  SourcesFleetsIdAlertsNoDataAlertLayoutRoute._addFileChildren(
    SourcesFleetsIdAlertsNoDataAlertLayoutRouteChildren,
  )

interface SourcesFleetsIdAlertsLayoutRouteChildren {
  SourcesFleetsIdAlertsNoDataAlertLayoutRoute: typeof SourcesFleetsIdAlertsNoDataAlertLayoutRouteWithChildren
  SourcesFleetsIdAlertsIndexRoute: typeof SourcesFleetsIdAlertsIndexRoute
  SourcesFleetsIdAlertsAlertIdIndexRoute: typeof SourcesFleetsIdAlertsAlertIdIndexRoute
}

const SourcesFleetsIdAlertsLayoutRouteChildren: SourcesFleetsIdAlertsLayoutRouteChildren =
  {
    SourcesFleetsIdAlertsNoDataAlertLayoutRoute:
      SourcesFleetsIdAlertsNoDataAlertLayoutRouteWithChildren,
    SourcesFleetsIdAlertsIndexRoute: SourcesFleetsIdAlertsIndexRoute,
    SourcesFleetsIdAlertsAlertIdIndexRoute:
      SourcesFleetsIdAlertsAlertIdIndexRoute,
  }

const SourcesFleetsIdAlertsLayoutRouteWithChildren =
  SourcesFleetsIdAlertsLayoutRoute._addFileChildren(
    SourcesFleetsIdAlertsLayoutRouteChildren,
  )

interface SourcesFleetsIdCloudStorageLayoutRouteChildren {
  SourcesFleetsIdCloudStorageIndexRoute: typeof SourcesFleetsIdCloudStorageIndexRoute
  SourcesFleetsIdCloudStorageDatabasesIndexRoute: typeof SourcesFleetsIdCloudStorageDatabasesIndexRoute
  SourcesFleetsIdCloudStorageParentDbSyncIndexRoute: typeof SourcesFleetsIdCloudStorageParentDbSyncIndexRoute
}

const SourcesFleetsIdCloudStorageLayoutRouteChildren: SourcesFleetsIdCloudStorageLayoutRouteChildren =
  {
    SourcesFleetsIdCloudStorageIndexRoute:
      SourcesFleetsIdCloudStorageIndexRoute,
    SourcesFleetsIdCloudStorageDatabasesIndexRoute:
      SourcesFleetsIdCloudStorageDatabasesIndexRoute,
    SourcesFleetsIdCloudStorageParentDbSyncIndexRoute:
      SourcesFleetsIdCloudStorageParentDbSyncIndexRoute,
  }

const SourcesFleetsIdCloudStorageLayoutRouteWithChildren =
  SourcesFleetsIdCloudStorageLayoutRoute._addFileChildren(
    SourcesFleetsIdCloudStorageLayoutRouteChildren,
  )

interface SourcesFleetsIdLayoutRouteChildren {
  SourcesFleetsIdAlertsLayoutRoute: typeof SourcesFleetsIdAlertsLayoutRouteWithChildren
  SourcesFleetsIdCloudStorageLayoutRoute: typeof SourcesFleetsIdCloudStorageLayoutRouteWithChildren
  SourcesFleetsIdIndexRoute: typeof SourcesFleetsIdIndexRoute
  SourcesFleetsIdConfigurationsIndexRoute: typeof SourcesFleetsIdConfigurationsIndexRoute
  SourcesFleetsIdDashboardsIndexRoute: typeof SourcesFleetsIdDashboardsIndexRoute
  SourcesFleetsIdEdgeGatewaysIndexRoute: typeof SourcesFleetsIdEdgeGatewaysIndexRoute
  SourcesFleetsIdGeneralIndexRoute: typeof SourcesFleetsIdGeneralIndexRoute
  SourcesFleetsIdReportsIndexRoute: typeof SourcesFleetsIdReportsIndexRoute
  SourcesFleetsIdResourcesIndexRoute: typeof SourcesFleetsIdResourcesIndexRoute
}

const SourcesFleetsIdLayoutRouteChildren: SourcesFleetsIdLayoutRouteChildren = {
  SourcesFleetsIdAlertsLayoutRoute:
    SourcesFleetsIdAlertsLayoutRouteWithChildren,
  SourcesFleetsIdCloudStorageLayoutRoute:
    SourcesFleetsIdCloudStorageLayoutRouteWithChildren,
  SourcesFleetsIdIndexRoute: SourcesFleetsIdIndexRoute,
  SourcesFleetsIdConfigurationsIndexRoute:
    SourcesFleetsIdConfigurationsIndexRoute,
  SourcesFleetsIdDashboardsIndexRoute: SourcesFleetsIdDashboardsIndexRoute,
  SourcesFleetsIdEdgeGatewaysIndexRoute: SourcesFleetsIdEdgeGatewaysIndexRoute,
  SourcesFleetsIdGeneralIndexRoute: SourcesFleetsIdGeneralIndexRoute,
  SourcesFleetsIdReportsIndexRoute: SourcesFleetsIdReportsIndexRoute,
  SourcesFleetsIdResourcesIndexRoute: SourcesFleetsIdResourcesIndexRoute,
}

const SourcesFleetsIdLayoutRouteWithChildren =
  SourcesFleetsIdLayoutRoute._addFileChildren(
    SourcesFleetsIdLayoutRouteChildren,
  )

interface SourcesProjectsIdReportsLayoutRouteChildren {
  SourcesProjectsIdReportsIndexRoute: typeof SourcesProjectsIdReportsIndexRoute
  SourcesProjectsIdReportsReportConfigIdIndexRoute: typeof SourcesProjectsIdReportsReportConfigIdIndexRoute
}

const SourcesProjectsIdReportsLayoutRouteChildren: SourcesProjectsIdReportsLayoutRouteChildren =
  {
    SourcesProjectsIdReportsIndexRoute: SourcesProjectsIdReportsIndexRoute,
    SourcesProjectsIdReportsReportConfigIdIndexRoute:
      SourcesProjectsIdReportsReportConfigIdIndexRoute,
  }

const SourcesProjectsIdReportsLayoutRouteWithChildren =
  SourcesProjectsIdReportsLayoutRoute._addFileChildren(
    SourcesProjectsIdReportsLayoutRouteChildren,
  )

interface SourcesProjectsIdLayoutRouteChildren {
  SourcesProjectsIdReportsLayoutRoute: typeof SourcesProjectsIdReportsLayoutRouteWithChildren
  SourcesProjectsIdIndexRoute: typeof SourcesProjectsIdIndexRoute
  SourcesProjectsIdDashboardsIndexRoute: typeof SourcesProjectsIdDashboardsIndexRoute
  SourcesProjectsIdEdgeGatewaysIndexRoute: typeof SourcesProjectsIdEdgeGatewaysIndexRoute
  SourcesProjectsIdGeneralIndexRoute: typeof SourcesProjectsIdGeneralIndexRoute
  SourcesProjectsIdResourcesIndexRoute: typeof SourcesProjectsIdResourcesIndexRoute
}

const SourcesProjectsIdLayoutRouteChildren: SourcesProjectsIdLayoutRouteChildren =
  {
    SourcesProjectsIdReportsLayoutRoute:
      SourcesProjectsIdReportsLayoutRouteWithChildren,
    SourcesProjectsIdIndexRoute: SourcesProjectsIdIndexRoute,
    SourcesProjectsIdDashboardsIndexRoute:
      SourcesProjectsIdDashboardsIndexRoute,
    SourcesProjectsIdEdgeGatewaysIndexRoute:
      SourcesProjectsIdEdgeGatewaysIndexRoute,
    SourcesProjectsIdGeneralIndexRoute: SourcesProjectsIdGeneralIndexRoute,
    SourcesProjectsIdResourcesIndexRoute: SourcesProjectsIdResourcesIndexRoute,
  }

const SourcesProjectsIdLayoutRouteWithChildren =
  SourcesProjectsIdLayoutRoute._addFileChildren(
    SourcesProjectsIdLayoutRouteChildren,
  )

interface SourcesLayoutRouteChildren {
  SourcesIndexRoute: typeof SourcesIndexRoute
  SourcesConfigurationsIdLayoutRoute: typeof SourcesConfigurationsIdLayoutRoute
  SourcesEdgeGatewaysIdLayoutRoute: typeof SourcesEdgeGatewaysIdLayoutRouteWithChildren
  SourcesFleetsIdLayoutRoute: typeof SourcesFleetsIdLayoutRouteWithChildren
  SourcesProjectsIdLayoutRoute: typeof SourcesProjectsIdLayoutRouteWithChildren
  SourcesConfigurationsIndexRoute: typeof SourcesConfigurationsIndexRoute
  SourcesEdgeGatewaysIndexRoute: typeof SourcesEdgeGatewaysIndexRoute
  SourcesFleetsIndexRoute: typeof SourcesFleetsIndexRoute
  SourcesProjectsIndexRoute: typeof SourcesProjectsIndexRoute
  SourcesHomeIndexLazyRoute: typeof SourcesHomeIndexLazyRoute
}

const SourcesLayoutRouteChildren: SourcesLayoutRouteChildren = {
  SourcesIndexRoute: SourcesIndexRoute,
  SourcesConfigurationsIdLayoutRoute: SourcesConfigurationsIdLayoutRoute,
  SourcesEdgeGatewaysIdLayoutRoute:
    SourcesEdgeGatewaysIdLayoutRouteWithChildren,
  SourcesFleetsIdLayoutRoute: SourcesFleetsIdLayoutRouteWithChildren,
  SourcesProjectsIdLayoutRoute: SourcesProjectsIdLayoutRouteWithChildren,
  SourcesConfigurationsIndexRoute: SourcesConfigurationsIndexRoute,
  SourcesEdgeGatewaysIndexRoute: SourcesEdgeGatewaysIndexRoute,
  SourcesFleetsIndexRoute: SourcesFleetsIndexRoute,
  SourcesProjectsIndexRoute: SourcesProjectsIndexRoute,
  SourcesHomeIndexLazyRoute: SourcesHomeIndexLazyRoute,
}

const SourcesLayoutRouteWithChildren = SourcesLayoutRoute._addFileChildren(
  SourcesLayoutRouteChildren,
)

interface StorageHubCaptureStorageBlobIdLayoutRouteChildren {
  StorageHubCaptureStorageBlobIdSettingsRoute: typeof StorageHubCaptureStorageBlobIdSettingsRoute
  StorageHubCaptureStorageBlobIdIndexRoute: typeof StorageHubCaptureStorageBlobIdIndexRoute
}

const StorageHubCaptureStorageBlobIdLayoutRouteChildren: StorageHubCaptureStorageBlobIdLayoutRouteChildren =
  {
    StorageHubCaptureStorageBlobIdSettingsRoute:
      StorageHubCaptureStorageBlobIdSettingsRoute,
    StorageHubCaptureStorageBlobIdIndexRoute:
      StorageHubCaptureStorageBlobIdIndexRoute,
  }

const StorageHubCaptureStorageBlobIdLayoutRouteWithChildren =
  StorageHubCaptureStorageBlobIdLayoutRoute._addFileChildren(
    StorageHubCaptureStorageBlobIdLayoutRouteChildren,
  )

interface StorageHubCaptureStorageDatabaseIdLayoutRouteChildren {
  StorageHubCaptureStorageDatabaseIdMeasurementsRoute: typeof StorageHubCaptureStorageDatabaseIdMeasurementsRoute
  StorageHubCaptureStorageDatabaseIdPermissionsRoute: typeof StorageHubCaptureStorageDatabaseIdPermissionsRoute
  StorageHubCaptureStorageDatabaseIdSettingsRoute: typeof StorageHubCaptureStorageDatabaseIdSettingsRoute
  StorageHubCaptureStorageDatabaseIdIndexRoute: typeof StorageHubCaptureStorageDatabaseIdIndexRoute
}

const StorageHubCaptureStorageDatabaseIdLayoutRouteChildren: StorageHubCaptureStorageDatabaseIdLayoutRouteChildren =
  {
    StorageHubCaptureStorageDatabaseIdMeasurementsRoute:
      StorageHubCaptureStorageDatabaseIdMeasurementsRoute,
    StorageHubCaptureStorageDatabaseIdPermissionsRoute:
      StorageHubCaptureStorageDatabaseIdPermissionsRoute,
    StorageHubCaptureStorageDatabaseIdSettingsRoute:
      StorageHubCaptureStorageDatabaseIdSettingsRoute,
    StorageHubCaptureStorageDatabaseIdIndexRoute:
      StorageHubCaptureStorageDatabaseIdIndexRoute,
  }

const StorageHubCaptureStorageDatabaseIdLayoutRouteWithChildren =
  StorageHubCaptureStorageDatabaseIdLayoutRoute._addFileChildren(
    StorageHubCaptureStorageDatabaseIdLayoutRouteChildren,
  )

interface StorageHubCaptureStorageLayoutRouteChildren {
  StorageHubCaptureStorageIndexRoute: typeof StorageHubCaptureStorageIndexRoute
  StorageHubCaptureStorageBlobIdLayoutRoute: typeof StorageHubCaptureStorageBlobIdLayoutRouteWithChildren
  StorageHubCaptureStorageDatabaseIdLayoutRoute: typeof StorageHubCaptureStorageDatabaseIdLayoutRouteWithChildren
  StorageHubCaptureStorageBlobIndexRoute: typeof StorageHubCaptureStorageBlobIndexRoute
  StorageHubCaptureStorageDatabaseIndexRoute: typeof StorageHubCaptureStorageDatabaseIndexRoute
}

const StorageHubCaptureStorageLayoutRouteChildren: StorageHubCaptureStorageLayoutRouteChildren =
  {
    StorageHubCaptureStorageIndexRoute: StorageHubCaptureStorageIndexRoute,
    StorageHubCaptureStorageBlobIdLayoutRoute:
      StorageHubCaptureStorageBlobIdLayoutRouteWithChildren,
    StorageHubCaptureStorageDatabaseIdLayoutRoute:
      StorageHubCaptureStorageDatabaseIdLayoutRouteWithChildren,
    StorageHubCaptureStorageBlobIndexRoute:
      StorageHubCaptureStorageBlobIndexRoute,
    StorageHubCaptureStorageDatabaseIndexRoute:
      StorageHubCaptureStorageDatabaseIndexRoute,
  }

const StorageHubCaptureStorageLayoutRouteWithChildren =
  StorageHubCaptureStorageLayoutRoute._addFileChildren(
    StorageHubCaptureStorageLayoutRouteChildren,
  )

interface StorageHubLayoutRouteChildren {
  StorageHubCaptureStorageLayoutRoute: typeof StorageHubCaptureStorageLayoutRouteWithChildren
  StorageHubIndexRoute: typeof StorageHubIndexRoute
}

const StorageHubLayoutRouteChildren: StorageHubLayoutRouteChildren = {
  StorageHubCaptureStorageLayoutRoute:
    StorageHubCaptureStorageLayoutRouteWithChildren,
  StorageHubIndexRoute: StorageHubIndexRoute,
}

const StorageHubLayoutRouteWithChildren =
  StorageHubLayoutRoute._addFileChildren(StorageHubLayoutRouteChildren)

interface UnsLayoutRouteChildren {
  UnsIndexRoute: typeof UnsIndexRoute
  UnsDataExplorerIndexRoute: typeof UnsDataExplorerIndexRoute
  UnsMetadatabundlesIndexRoute: typeof UnsMetadatabundlesIndexRoute
  UnsUnsBuilderIndexRoute: typeof UnsUnsBuilderIndexRoute
  UnsHomeIndexLazyRoute: typeof UnsHomeIndexLazyRoute
}

const UnsLayoutRouteChildren: UnsLayoutRouteChildren = {
  UnsIndexRoute: UnsIndexRoute,
  UnsDataExplorerIndexRoute: UnsDataExplorerIndexRoute,
  UnsMetadatabundlesIndexRoute: UnsMetadatabundlesIndexRoute,
  UnsUnsBuilderIndexRoute: UnsUnsBuilderIndexRoute,
  UnsHomeIndexLazyRoute: UnsHomeIndexLazyRoute,
}

const UnsLayoutRouteWithChildren = UnsLayoutRoute._addFileChildren(
  UnsLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  AdminLayoutRoute: AdminLayoutRouteWithChildren,
  IdentityAndAccessLayoutRoute: IdentityAndAccessLayoutRouteWithChildren,
  ResourcesLayoutRoute: ResourcesLayoutRouteWithChildren,
  SourcesLayoutRoute: SourcesLayoutRouteWithChildren,
  StorageHubLayoutRoute: StorageHubLayoutRouteWithChildren,
  UnsLayoutRoute: UnsLayoutRouteWithChildren,
  AppIdRoute: AppIdRoute,
  CaptainAiChatIdRoute: CaptainAiChatIdRoute,
  CaptainAiIndexRoute: CaptainAiIndexRoute,
  CaptureIndexRoute: CaptureIndexRoute,
  DashboardsIndexRoute: DashboardsIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  DashboardsIdIndexRoute: DashboardsIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
